export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Decimal: number;
  Duration: string;
  Instant: any;
  LocalDate: string;
  UUID: any;
};

export type AddBadDebtWriteOffCommand = {
  amount: Scalars['Decimal'];
  customerNumber: Scalars['String'];
  date: Scalars['LocalDate'];
};

export type AddInvoicesToRollupResult = {
  __typename?: 'AddInvoicesToRollupResult';
  invoiceCount: Scalars['Int'];
  invoiceNumber: Scalars['String'];
  projectGroup: Scalars['String'];
};

export type AddProductRateCommand = {
  amount?: InputMaybe<Scalars['Decimal']>;
  productId: Scalars['Int'];
};

export type AddProjectRequestReviewerCommand = {
  officeCode: Scalars['String'];
  userPrincipalName: Scalars['String'];
};

export type AddProjectToGroupedFolderCommand = {
  groupedFolderId: Scalars['Int'];
  projectNumber: Scalars['Int'];
};

export type AddRatesCommand = {
  effectiveDate: Scalars['LocalDate'];
  locations: Array<StateCountyInput>;
  lodgingBillable: Scalars['Decimal'];
  lodgingReimbursable: Scalars['Decimal'];
  mealsBillable: Scalars['Decimal'];
  mealsReimbursable: Scalars['Decimal'];
  travelBillable: Scalars['Decimal'];
  travelReimbursable: Scalars['Decimal'];
};

export type AddRollupInvoiceLineItemCommand = {
  customRollupInvoiceNumber: Scalars['String'];
  invoiceNumber: Scalars['String'];
};

export type AdHocExpense = IExpense & {
  __typename?: 'AdHocExpense';
  billableAmount?: Maybe<Scalars['Decimal']>;
  date: Scalars['LocalDate'];
  eeCode: Scalars['String'];
  expenseAccount?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  glAccount?: Maybe<Scalars['String']>;
  history: Array<ExpenseHistoryItem>;
  id: Scalars['String'];
  importEdited: Scalars['Boolean'];
  invoiceLabel?: Maybe<Scalars['String']>;
  lastAdminNotes?: Maybe<Scalars['String']>;
  location: StateCounty;
  notes?: Maybe<Scalars['String']>;
  payable: Payable;
  payableAmount: Scalars['Decimal'];
  payableOverridden: Scalars['Boolean'];
  projectId: Scalars['Int'];
  quantity: Scalars['Decimal'];
  rate: Scalars['Decimal'];
  rateName: Scalars['String'];
  rateSheetName: Scalars['String'];
  receiptImageId?: Maybe<Scalars['String']>;
  receiptImageUrl?: Maybe<Scalars['String']>;
};

export type AdHocExpenseRate = IExpenseRate & {
  __typename?: 'AdHocExpenseRate';
  expenseAccount?: Maybe<Scalars['String']>;
  glAccount?: Maybe<Scalars['String']>;
  invoiceLabel?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  rate?: Maybe<Scalars['Decimal']>;
  unit?: Maybe<RateUnit>;
};

export type AppNotification = {
  __typename?: 'AppNotification';
  createdOn: Scalars['Instant'];
  id: Scalars['UUID'];
  readOn?: Maybe<Scalars['Instant']>;
  recipient: Employee;
  subjectId: Scalars['String'];
  subjectType: SubjectType;
};

export type AppNotificationMutationModel = {
  __typename?: 'AppNotificationMutationModel';
  markAllRead: ValidationResponse;
  markRead: ValidationResponse;
};


export type AppNotificationMutationModelMarkReadArgs = {
  input: MarkReadCommand;
};

export type AppNotificationQueryModel = {
  __typename?: 'AppNotificationQueryModel';
  getNotifications: NotificationsResult;
};

export type ApproveCustomerCommand = {
  createCustomerRequestId: Scalars['String'];
  number: Scalars['String'];
  subNumber: Scalars['String'];
};

export type ApproveRequestGroupCommand = {
  assignExpenseRateSheet?: InputMaybe<AssignRateSheetArgsInput>;
  assignTaskRateSheet?: InputMaybe<AssignRateSheetArgsInput>;
  billingAdmin: Scalars['String'];
  billingFrequency: BillingFrequencyType;
  corpLocation: Scalars['String'];
  customerSubAccountOf?: InputMaybe<Scalars['String']>;
  division: Scalars['String'];
  invoiceNotes?: InputMaybe<Scalars['String']>;
  memberId: Scalars['String'];
  projectSupervisor: Scalars['String'];
};

export type AssignRateSheetArgsInput = {
  effectiveDate: Scalars['LocalDate'];
  rateSheetName: Scalars['String'];
};

export type AtvExpense = IExpense & {
  __typename?: 'AtvExpense';
  billableAmount?: Maybe<Scalars['Decimal']>;
  date: Scalars['LocalDate'];
  eeCode: Scalars['String'];
  expenseAccount?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  glAccount?: Maybe<Scalars['String']>;
  history: Array<ExpenseHistoryItem>;
  id: Scalars['String'];
  importEdited: Scalars['Boolean'];
  invoiceLabel?: Maybe<Scalars['String']>;
  lastAdminNotes?: Maybe<Scalars['String']>;
  location: StateCounty;
  notes?: Maybe<Scalars['String']>;
  payable: Payable;
  payableAmount: Scalars['Decimal'];
  payableOverridden: Scalars['Boolean'];
  projectId: Scalars['Int'];
  rateName: Scalars['String'];
  rateSheetName: Scalars['String'];
};

export type AtvExpenseRate = IExpenseRate & {
  __typename?: 'AtvExpenseRate';
  billableAmount?: Maybe<Scalars['Decimal']>;
  expenseAccount?: Maybe<Scalars['String']>;
  glAccount?: Maybe<Scalars['String']>;
  invoiceLabel?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  reimbursableAmount: Scalars['Decimal'];
  unit?: Maybe<RateUnit>;
};

export type AuthorizationQueryModel = {
  __typename?: 'AuthorizationQueryModel';
  clientAuthorizations: ClientAuthorizations;
  legacyAuthorizations: LegacyAuthorizations;
};

export type BaApproveProjectChargesCommand = {
  projectCharges: Array<Scalars['Int']>;
};

export type BadDebtPaid = {
  __typename?: 'BadDebtPaid';
  amount: Scalars['Decimal'];
  date: Scalars['LocalDate'];
};

export type BadDebtWriteOff = {
  __typename?: 'BadDebtWriteOff';
  amount: Scalars['Decimal'];
  cleared: Scalars['Boolean'];
  customerId: Scalars['Int'];
  date: Scalars['LocalDate'];
  id: Scalars['Int'];
  payments: Array<BadDebtPaid>;
};

export type BadDebtWriteOffCreatedResponse = {
  __typename?: 'BadDebtWriteOffCreatedResponse';
  badDebtWriteOffId?: Maybe<Scalars['Int']>;
  errors: Array<ValidationError>;
};

export enum BillingFrequencyType {
  Weekly = 'Weekly',
  Biweekly = 'Biweekly',
  Monthly = 'Monthly',
  UponCompletion = 'UponCompletion'
}

export type BillRollupInvoiceCommand = {
  invoiceNumber: Scalars['String'];
};

export type BulkAddInvoicesResponse = {
  __typename?: 'BulkAddInvoicesResponse';
  errors: Array<ValidationError>;
  results: Array<AddInvoicesToRollupResult>;
};

export type BulkAddRollupLineItemsArgsInput = {
  customRollupInvoiceNumber?: InputMaybe<Scalars['String']>;
  invoiceNumbers: Array<Scalars['String']>;
};

export type BulkAddRollupLineItemsCommand = {
  addInvoicesArgs: Array<BulkAddRollupLineItemsArgsInput>;
};

export type BulkDraftRollupInvoicesArgsInput = {
  groupIds: Array<Scalars['Int']>;
};

export type CancelRollupInvoiceCommand = {
  invoiceNumber: Scalars['String'];
  notes: Scalars['String'];
};

export type ChangeProjectChargesProjectCommand = {
  editNotes: Scalars['String'];
  newProjectId: Scalars['Int'];
  projectCharges: Array<Scalars['Int']>;
};

export type ChangeServiceDescriptionActiveInput = {
  displayName: Scalars['String'];
  isActive: Scalars['Boolean'];
};

export enum ChargeType {
  Task = 'Task',
  Expense = 'Expense',
  Tax = 'Tax',
  Clerical = 'Clerical'
}

export type CheckoutProjectRequestGroupCommand = {
  overrideCheckout: Scalars['Boolean'];
  requestId: Scalars['String'];
};

export type ClientAuthorizations = {
  __typename?: 'ClientAuthorizations';
  commands: Array<CommandAuthorization>;
  menus: Array<MenuAuthorizations>;
};

/** An exhaustive list of all command types that can be authorized by roles */
export enum CommandAuthorization {
  AssignTaskRateSheetToProjectCommand = 'AssignTaskRateSheetToProjectCommand',
  RemoveTaskRateSheetFromProjectCommand = 'RemoveTaskRateSheetFromProjectCommand',
  StartRebuildProjectChargeIndexCommand = 'StartRebuildProjectChargeIndexCommand',
  CreateProjectCommand = 'CreateProjectCommand',
  EditActualEndDateCommand = 'EditActualEndDateCommand',
  EditActualStartDateCommand = 'EditActualStartDateCommand',
  EditAfeCommand = 'EditAfeCommand',
  EditAllowThirdPartyInvoiceCommand = 'EditAllowThirdPartyInvoiceCommand',
  EditBillingAdminCommand = 'EditBillingAdminCommand',
  EditBillingFrequencyCommand = 'EditBillingFrequencyCommand',
  EditBlockCommand = 'EditBlockCommand',
  EditBudgetCommand = 'EditBudgetCommand',
  EditCityCommand = 'EditCityCommand',
  EditClientContactNameCommand = 'EditClientContactNameCommand',
  EditContractNumberCommand = 'EditContractNumberCommand',
  EditCorpLocationCommand = 'EditCorpLocationCommand',
  EditCostCenterCommand = 'EditCostCenterCommand',
  EditCustomerCommand = 'EditCustomerCommand',
  EditDateInCommand = 'EditDateInCommand',
  EditDescriptionCommand = 'EditDescriptionCommand',
  EditDivisionCommand = 'EditDivisionCommand',
  EditEogAfeTypeCommand = 'EditEogAfeTypeCommand',
  EditEstimatedEndDateCommand = 'EditEstimatedEndDateCommand',
  EditEstimatedStartDateCommand = 'EditEstimatedStartDateCommand',
  EditGlCodeCommand = 'EditGlCodeCommand',
  EditGovernmentFundingCommand = 'EditGovernmentFundingCommand',
  EditInternalNotesCommand = 'EditInternalNotesCommand',
  EditInvoiceNotesCommand = 'EditInvoiceNotesCommand',
  EditLatitudeCommand = 'EditLatitudeCommand',
  EditLocationCommand = 'EditLocationCommand',
  EditLongitudeCommand = 'EditLongitudeCommand',
  EditNetworkPathCommand = 'EditNetworkPathCommand',
  EditOfficeCodeCommand = 'EditOfficeCodeCommand',
  EditPoCommand = 'EditPoCommand',
  EditProjectCertifiedPayrollCommand = 'EditProjectCertifiedPayrollCommand',
  EditProjectManagerCommand = 'EditProjectManagerCommand',
  EditProjectNameCommand = 'EditProjectNameCommand',
  EditProjectOriginationCommand = 'EditProjectOriginationCommand',
  EditProjectProjectGroupCommand = 'EditProjectProjectGroupCommand',
  EditProjectStatusCommand = 'EditProjectStatusCommand',
  EditProjectSupervisorCommand = 'EditProjectSupervisorCommand',
  EditRangeCommand = 'EditRangeCommand',
  EditRequisitionerCommand = 'EditRequisitionerCommand',
  EditScopeCommand = 'EditScopeCommand',
  EditSectionCommand = 'EditSectionCommand',
  EditServiceDescriptionCommand = 'EditServiceDescriptionCommand',
  EditSurveyCommand = 'EditSurveyCommand',
  EditTownshipCommand = 'EditTownshipCommand',
  EditWoCommand = 'EditWoCommand',
  CreateProjectGroupCommand = 'CreateProjectGroupCommand',
  EditProjectGroupCommand = 'EditProjectGroupCommand',
  CreateInvoiceChargeCommand = 'CreateInvoiceChargeCommand',
  AddProductRateCommand = 'AddProductRateCommand',
  CreateProductCommand = 'CreateProductCommand',
  RenameProductCommand = 'RenameProductCommand',
  AddRatesCommand = 'AddRatesCommand',
  AddChargesToInvoiceCommand = 'AddChargesToInvoiceCommand',
  AddChargeToInvoiceCommand = 'AddChargeToInvoiceCommand',
  BillInvoiceCommand = 'BillInvoiceCommand',
  CreateInvoiceCommand = 'CreateInvoiceCommand',
  RemoveChargeFromInvoiceCommand = 'RemoveChargeFromInvoiceCommand',
  OverrideCustomerFolderSyncCommand = 'OverrideCustomerFolderSyncCommand',
  OverrideGroupedFolderSyncCommand = 'OverrideGroupedFolderSyncCommand',
  OverrideProjectFolderSyncCommand = 'OverrideProjectFolderSyncCommand',
  CompleteProjectFolderMoveCommand = 'CompleteProjectFolderMoveCommand',
  CompleteGroupedFolderMoveCommand = 'CompleteGroupedFolderMoveCommand',
  RequestProjectFolderMoveCommand = 'RequestProjectFolderMoveCommand',
  RequestGroupedFolderMoveCommand = 'RequestGroupedFolderMoveCommand',
  AddProjectToGroupedFolderCommand = 'AddProjectToGroupedFolderCommand',
  CreateGroupedFolderForProjectCommand = 'CreateGroupedFolderForProjectCommand',
  CreateProjectFolderCommand = 'CreateProjectFolderCommand',
  AddProjectRequestReviewerCommand = 'AddProjectRequestReviewerCommand',
  RemoveProjectRequestReviewerCommand = 'RemoveProjectRequestReviewerCommand',
  UpdateFieldOfficeProjectAffinityCommand = 'UpdateFieldOfficeProjectAffinityCommand',
  AssignToProjectCommand = 'AssignToProjectCommand',
  EditRateSheetCommand = 'EditRateSheetCommand',
  RemoveExpenseRateSheetFromProjectCommand = 'RemoveExpenseRateSheetFromProjectCommand',
  UpdateDefaultDriveCommand = 'UpdateDefaultDriveCommand',
  CreateEmployeeRateCommand = 'CreateEmployeeRateCommand',
  DeleteEmployeeRateCommand = 'DeleteEmployeeRateCommand',
  EditEmployeeRateCommand = 'EditEmployeeRateCommand',
  UpdateEeCodeActiveCommand = 'UpdateEeCodeActiveCommand',
  UpdateOfficeOverheadEeCodeCommand = 'UpdateOfficeOverheadEeCodeCommand',
  UpdateStateOverheadEeCodeCommand = 'UpdateStateOverheadEeCodeCommand',
  UpsertEeCodeCommand = 'UpsertEeCodeCommand',
  AddRollupInvoiceLineItemCommand = 'AddRollupInvoiceLineItemCommand',
  BillRollupInvoiceCommand = 'BillRollupInvoiceCommand',
  BulkAddRollupLineItemsCommand = 'BulkAddRollupLineItemsCommand',
  CancelRollupInvoiceCommand = 'CancelRollupInvoiceCommand',
  CreateRollupInvoiceCommand = 'CreateRollupInvoiceCommand',
  EditRollupInvoiceCommand = 'EditRollupInvoiceCommand',
  RemoveRollupInvoiceLineItemCommand = 'RemoveRollupInvoiceLineItemCommand',
  ApproveCustomerCommand = 'ApproveCustomerCommand',
  RejectCustomerCommand = 'RejectCustomerCommand',
  CreateCustomerCommand = 'CreateCustomerCommand'
}

export type CompleteGroupedFolderMoveCommand = {
  folderId: Scalars['Int'];
};

export type CompleteProjectFolderMoveCommand = {
  folderId: Scalars['Int'];
};

export type ConnectionOfCustomer = {
  __typename?: 'ConnectionOfCustomer';
  records: Array<Customer>;
  token?: Maybe<Scalars['String']>;
};

export type ConnectionOfCustomRollupInvoice = {
  __typename?: 'ConnectionOfCustomRollupInvoice';
  records: Array<CustomRollupInvoice>;
  token?: Maybe<Scalars['String']>;
};

export type ConnectionOfTrainingReportRow = {
  __typename?: 'ConnectionOfTrainingReportRow';
  records: Array<TrainingReportRow>;
  token?: Maybe<Scalars['String']>;
};

export type CorpLocation = {
  __typename?: 'CorpLocation';
  companyName: Scalars['String'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
};

export type CorpLocationMutationModel = {
  __typename?: 'CorpLocationMutationModel';
  update: ValidationResponse;
};


export type CorpLocationMutationModelUpdateArgs = {
  input: UpdateCorpLocationCommand;
};

export type CorpLocationQueryModel = {
  __typename?: 'CorpLocationQueryModel';
  all: Array<CorpLocation>;
};

export type CreateCustomerCommand = {
  address1: Scalars['String'];
  address2: Scalars['String'];
  adminNotes?: InputMaybe<Scalars['String']>;
  attn?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  electronicInvoicingSystem?: InputMaybe<ElectronicInvoicingSystem>;
  fax: Scalars['String'];
  name: Scalars['String'];
  nmTaxable: Scalars['Boolean'];
  notes: Scalars['String'];
  phone: Scalars['String'];
  requiresEogAfeType: Scalars['Boolean'];
  state: Scalars['String'];
  subAccountOf?: InputMaybe<Scalars['String']>;
  txTaxable: Scalars['Boolean'];
  zip: Scalars['String'];
};

export type CreateCustomerResponse = {
  __typename?: 'CreateCustomerResponse';
  createCustomerRequestId: Scalars['UUID'];
  errors: Array<ValidationError>;
};

export type CreateEmployeeRateCommand = {
  effectiveDate: Scalars['LocalDate'];
  rate: Scalars['Decimal'];
  ultiProId: Scalars['String'];
};

export type CreateGroupedFolderCommand = {
  customerId: Scalars['Int'];
  driveLetter: Scalars['String'];
  folderName: Scalars['String'];
};

export type CreateGroupedFolderForProjectCommand = {
  driveLetter: Scalars['String'];
  folderName: Scalars['String'];
  projectNumber: Scalars['Int'];
};

export type CreateInvoiceChargeCommand = {
  date: Scalars['LocalDate'];
  eeCode: Scalars['String'];
  employee?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  label: Scalars['String'];
  notes: Scalars['String'];
  projectNumber: Scalars['Int'];
  quantity: Scalars['Decimal'];
  rate: Scalars['Decimal'];
  rateSheetName?: InputMaybe<Scalars['String']>;
  taxable?: InputMaybe<Scalars['Boolean']>;
  type: ChargeType;
  unit?: InputMaybe<RateUnit>;
};

export type CreateProductCommand = {
  classification: PriceClassification;
  name: Scalars['String'];
  unit: ProductUnit;
};

export type CreateProjectChargeCommand = {
  date: Scalars['LocalDate'];
  eeCode: Scalars['String'];
  employee?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  label: Scalars['String'];
  notes: Scalars['String'];
  projectNumber: Scalars['Int'];
  quantity: Scalars['Decimal'];
  rate: Scalars['Decimal'];
  rateSheetName?: InputMaybe<Scalars['String']>;
  taxable?: InputMaybe<Scalars['Boolean']>;
  type: ChargeType;
  unit?: InputMaybe<RateUnit>;
};

export type CreateProjectChargeResponse = {
  __typename?: 'CreateProjectChargeResponse';
  errors: Array<ValidationError>;
  projectChargeId?: Maybe<Scalars['Int']>;
};

export type CreateProjectFolderCommand = {
  driveLetter: Scalars['String'];
  projectNumber: Scalars['Int'];
};

export type CreateProjectRequestCommand = {
  additionalComments?: InputMaybe<Scalars['String']>;
  afe?: InputMaybe<Scalars['String']>;
  block?: InputMaybe<Scalars['String']>;
  budget?: InputMaybe<Scalars['Decimal']>;
  certifiedPayroll?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  clientContactName: Scalars['String'];
  coGo?: InputMaybe<Scalars['String']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  costCenter?: InputMaybe<Scalars['String']>;
  county: Scalars['String'];
  customer?: InputMaybe<ProjectRequestCustomerArgsInput>;
  eogAfeType?: InputMaybe<EogAfeTypeMutationInput>;
  fieldContact?: InputMaybe<Scalars['String']>;
  fieldInstructions?: InputMaybe<Scalars['String']>;
  fieldMeetInfo?: InputMaybe<Scalars['String']>;
  folder?: InputMaybe<ProjectRequestFolderArgsInput>;
  glCode?: InputMaybe<Scalars['String']>;
  governmentFunding: GovernmentFundingType;
  invoiceContact?: InputMaybe<Scalars['String']>;
  invoiceSubmitEmail?: InputMaybe<Scalars['String']>;
  jobsFolderRequired: Scalars['Boolean'];
  latitude?: InputMaybe<Scalars['Decimal']>;
  longitude?: InputMaybe<Scalars['Decimal']>;
  name: Scalars['String'];
  officeCode: Scalars['String'];
  officeInstructions?: InputMaybe<Scalars['String']>;
  po?: InputMaybe<Scalars['String']>;
  projectInstructions?: InputMaybe<Scalars['String']>;
  projectManager: Scalars['String'];
  projectOrigination: ProjectOrigination;
  projectOriginationName?: InputMaybe<Scalars['String']>;
  range?: InputMaybe<Scalars['String']>;
  requisitioner?: InputMaybe<Scalars['String']>;
  scope: Scalars['String'];
  section?: InputMaybe<Scalars['String']>;
  serviceDescription: Scalars['String'];
  state: Scalars['String'];
  survey?: InputMaybe<Scalars['String']>;
  taxableServices: Scalars['Boolean'];
  township?: InputMaybe<Scalars['String']>;
  wo?: InputMaybe<Scalars['String']>;
};

export type CreateProjectRequestResponse = {
  __typename?: 'CreateProjectRequestResponse';
  errors: Array<ValidationError>;
  requestId?: Maybe<Scalars['UUID']>;
};

export type CreateRollupInvoiceCommand = {
  customerNumber: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  projectGroupName: Scalars['String'];
};

export type CreateRollupInvoiceResponse = {
  __typename?: 'CreateRollupInvoiceResponse';
  customRollupInvoiceNumber: Scalars['String'];
  errors: Array<ValidationError>;
};

export enum CrewRole {
  CrewChief = 'CrewChief',
  Rodman = 'Rodman',
  IMan = 'IMan'
}

export type Customer = {
  __typename?: 'Customer';
  address1: Scalars['String'];
  address2: Scalars['String'];
  adminNotes?: Maybe<Scalars['String']>;
  attn?: Maybe<Scalars['String']>;
  badDebtWriteOffs: Array<BadDebtWriteOff>;
  canManageCri: Scalars['Boolean'];
  city: Scalars['String'];
  country: Scalars['String'];
  createCustomerRequestId: Scalars['UUID'];
  customerId: Scalars['Int'];
  electronicInvoicingSystem?: Maybe<ElectronicInvoicingSystem>;
  fax: Scalars['String'];
  name: Scalars['String'];
  nmTaxable: Scalars['Boolean'];
  notes: Scalars['String'];
  number?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  projectGroups: Array<ProjectGroup>;
  requester?: Maybe<Employee>;
  requesterId?: Maybe<Scalars['Int']>;
  requiresEogAfeType: Scalars['Boolean'];
  simplifiedName: Scalars['String'];
  state: Scalars['String'];
  status: CustomerStatus;
  subAccountOf?: Maybe<Scalars['String']>;
  txTaxable: Scalars['Boolean'];
  zip: Scalars['String'];
};

export type CustomerFolder = {
  __typename?: 'CustomerFolder';
  customerNumber?: Maybe<Scalars['String']>;
  fullPath: Scalars['String'];
  groupedFolders: Array<GroupedFolder>;
  id: Scalars['Int'];
  path: Scalars['String'];
  projectFolders: Array<ProjectFolder>;
  syncErrorMessage?: Maybe<Scalars['String']>;
  syncStatus: SyncStatus;
};

export type CustomerMutationModel = {
  __typename?: 'CustomerMutationModel';
  addBadDebtWriteOff: BadDebtWriteOffCreatedResponse;
  approveCustomer: ValidationResponse;
  createCustomer: CreateCustomerResponse;
  editCustomer: ValidationResponse;
  editElectronicInvoicing: ValidationResponse;
  payBadDebt: ValidationResponse;
  rejectCustomer: ValidationResponse;
};


export type CustomerMutationModelAddBadDebtWriteOffArgs = {
  input: AddBadDebtWriteOffCommand;
};


export type CustomerMutationModelApproveCustomerArgs = {
  input: ApproveCustomerCommand;
};


export type CustomerMutationModelCreateCustomerArgs = {
  input: CreateCustomerCommand;
};


export type CustomerMutationModelEditCustomerArgs = {
  input: EditCustomerCommand;
};


export type CustomerMutationModelEditElectronicInvoicingArgs = {
  input: EditElectronicInvoicingCommand;
};


export type CustomerMutationModelPayBadDebtArgs = {
  input: PayBadDebtCommand;
};


export type CustomerMutationModelRejectCustomerArgs = {
  input: RejectCustomerCommand;
};

export type CustomersQueryModel2 = {
  __typename?: 'CustomersQueryModel2';
  pendingCustomers: Array<PendingCustomer>;
  search: ConnectionOfCustomer;
  single?: Maybe<Customer>;
};


export type CustomersQueryModel2SearchArgs = {
  input: CustomersSearchArgsInput;
};


export type CustomersQueryModel2SingleArgs = {
  input: SingleCustomerInput;
};

export type CustomersSearchArgsInput = {
  includeInProjectRequest?: InputMaybe<Scalars['Boolean']>;
  includePending?: InputMaybe<Scalars['Boolean']>;
  projectNumber?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

export enum CustomerStatus {
  Approved = 'Approved',
  InProjectRequest = 'InProjectRequest',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

export type CustomRollupInvoice = {
  __typename?: 'CustomRollupInvoice';
  cancelledDate?: Maybe<Scalars['LocalDate']>;
  id: Scalars['Int'];
  invoiceDate?: Maybe<Scalars['LocalDate']>;
  invoiceNumber: Scalars['String'];
  lineItems: Array<CustomRollupInvoiceLineItem>;
  notes?: Maybe<Scalars['String']>;
  pdfDownloadUrl: Scalars['String'];
  projectGroup: ProjectGroup;
  projectGroupId: Scalars['Int'];
  projectGroupName: Scalars['String'];
  state: InvoiceState;
  total: Scalars['Decimal'];
};

export type CustomRollupInvoiceLineItem = {
  __typename?: 'CustomRollupInvoiceLineItem';
  customRollupInvoiceId: Scalars['Int'];
  invoice: Invoice;
  invoiceId: Scalars['Int'];
  total: Scalars['Decimal'];
};

export type CustomRollupInvoiceMutationModel2 = {
  __typename?: 'CustomRollupInvoiceMutationModel2';
  addLineItem: ValidationResponse;
  bill: ValidationResponse;
  bulkAddLineItems: BulkAddInvoicesResponse;
  cancel: ValidationResponse;
  create: CreateRollupInvoiceResponse;
  edit: ValidationResponse;
  removeLineItem: ValidationResponse;
};


export type CustomRollupInvoiceMutationModel2AddLineItemArgs = {
  input: AddRollupInvoiceLineItemCommand;
};


export type CustomRollupInvoiceMutationModel2BillArgs = {
  input: BillRollupInvoiceCommand;
};


export type CustomRollupInvoiceMutationModel2BulkAddLineItemsArgs = {
  input: BulkAddRollupLineItemsCommand;
};


export type CustomRollupInvoiceMutationModel2CancelArgs = {
  input: CancelRollupInvoiceCommand;
};


export type CustomRollupInvoiceMutationModel2CreateArgs = {
  input: CreateRollupInvoiceCommand;
};


export type CustomRollupInvoiceMutationModel2EditArgs = {
  input: EditRollupInvoiceCommand;
};


export type CustomRollupInvoiceMutationModel2RemoveLineItemArgs = {
  input: RemoveRollupInvoiceLineItemCommand;
};

export type CustomRollupInvoiceQueryModel2 = {
  __typename?: 'CustomRollupInvoiceQueryModel2';
  draftRollupInvoices: Array<CustomRollupInvoice>;
  search: ConnectionOfCustomRollupInvoice;
  single?: Maybe<CustomRollupInvoice>;
};


export type CustomRollupInvoiceQueryModel2DraftRollupInvoicesArgs = {
  input: BulkDraftRollupInvoicesArgsInput;
};


export type CustomRollupInvoiceQueryModel2SearchArgs = {
  input: CustomRollupInvoiceSearchArgsInput;
};


export type CustomRollupInvoiceQueryModel2SingleArgs = {
  input: SingleRollupInvoiceArgsInput;
};

export type CustomRollupInvoiceSearchArgsInput = {
  amount?: InputMaybe<Scalars['Decimal']>;
  customerNumber?: InputMaybe<Scalars['String']>;
  invoiceNumbers?: InputMaybe<Array<Scalars['String']>>;
  projectGroupArgs?: InputMaybe<ProjectGroupArgsInput>;
  searchText?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<CustomRollupInvoiceSortBy>;
  state?: InputMaybe<InvoiceFilterState>;
  token?: InputMaybe<Scalars['String']>;
};

export enum CustomRollupInvoiceSortBy {
  /** Customer Name */
  CustomerName = 'CustomerName',
  /** Invoice Number */
  InvoiceNumber = 'InvoiceNumber'
}

export type DeleteEmployeeRateCommand = {
  effectiveDate: Scalars['LocalDate'];
  ultiProId: Scalars['String'];
};

export type Division = {
  __typename?: 'Division';
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
};

export type DivisionMutationModel = {
  __typename?: 'DivisionMutationModel';
  update: ValidationResponse;
};


export type DivisionMutationModelUpdateArgs = {
  input: UpdateDivisionCommand;
};

export type DivisionQueryModel = {
  __typename?: 'DivisionQueryModel';
  all: Array<Division>;
};

export type EditCustomerCommand = {
  address1: Scalars['String'];
  address2: Scalars['String'];
  adminNotes?: InputMaybe<Scalars['String']>;
  attn?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  electronicInvoicingSystem?: InputMaybe<ElectronicInvoicingSystem>;
  fax: Scalars['String'];
  mainNumber?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  nmTaxable: Scalars['Boolean'];
  notes: Scalars['String'];
  number: Scalars['String'];
  phone: Scalars['String'];
  requiresEogAfeType: Scalars['Boolean'];
  state: Scalars['String'];
  subNumber?: InputMaybe<Scalars['String']>;
  txTaxable: Scalars['Boolean'];
  zip: Scalars['String'];
};

export type EditElectronicInvoicingCommand = {
  customerNumber: Scalars['String'];
  electronicInvoicingSystem?: InputMaybe<ElectronicInvoicingSystem>;
};

export type EditEmployeeRateCommand = {
  effectiveDate: Scalars['LocalDate'];
  originalEffectiveDate: Scalars['LocalDate'];
  rate: Scalars['Decimal'];
  ultiProId: Scalars['String'];
};

export type EditGroupCustomerCommand = {
  customer: ProjectRequestCustomerArgsInput;
  memberId: Scalars['String'];
  notes: Scalars['String'];
};

export type EditGroupOfficeCommand = {
  memberId: Scalars['String'];
  notes: Scalars['String'];
  officeCode: Scalars['String'];
};

export type EditProjectChargeCommand = {
  billable: Scalars['Boolean'];
  date?: InputMaybe<Scalars['LocalDate']>;
  editNotes: Scalars['String'];
  eeCode: Scalars['String'];
  employee?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  label: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['Int']>;
  quantity: Scalars['Decimal'];
  rate: Scalars['Decimal'];
  rateSheetName?: InputMaybe<Scalars['String']>;
  taxable?: InputMaybe<Scalars['Boolean']>;
  unit?: InputMaybe<RateUnit>;
};

export type EditProjectChargesEeCodeCommand = {
  editNotes: Scalars['String'];
  eeCode: Scalars['String'];
  projectCharges: Array<Scalars['Int']>;
};

export type EditProjectRequestCommand = {
  additionalComments?: InputMaybe<Scalars['String']>;
  afe?: InputMaybe<Scalars['String']>;
  block?: InputMaybe<Scalars['String']>;
  budget?: InputMaybe<Scalars['Decimal']>;
  certifiedPayroll?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  clientContactName: Scalars['String'];
  coGo?: InputMaybe<Scalars['String']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  costCenter?: InputMaybe<Scalars['String']>;
  county: Scalars['String'];
  customer?: InputMaybe<ProjectRequestCustomerArgsInput>;
  eogAfeType?: InputMaybe<EogAfeTypeMutationInput>;
  fieldContact?: InputMaybe<Scalars['String']>;
  fieldInstructions?: InputMaybe<Scalars['String']>;
  fieldMeetInfo?: InputMaybe<Scalars['String']>;
  folder?: InputMaybe<ProjectRequestFolderArgsInput>;
  glCode?: InputMaybe<Scalars['String']>;
  governmentFunding: GovernmentFundingType;
  invoiceContact?: InputMaybe<Scalars['String']>;
  invoiceSubmitEmail?: InputMaybe<Scalars['String']>;
  jobsFolderRequired: Scalars['Boolean'];
  latitude?: InputMaybe<Scalars['Decimal']>;
  longitude?: InputMaybe<Scalars['Decimal']>;
  name: Scalars['String'];
  notes: Scalars['String'];
  officeCode: Scalars['String'];
  officeInstructions?: InputMaybe<Scalars['String']>;
  po?: InputMaybe<Scalars['String']>;
  projectInstructions?: InputMaybe<Scalars['String']>;
  projectManager: Scalars['String'];
  projectOrigination: ProjectOrigination;
  projectOriginationName?: InputMaybe<Scalars['String']>;
  range?: InputMaybe<Scalars['String']>;
  requestId: Scalars['String'];
  requisitioner?: InputMaybe<Scalars['String']>;
  scope: Scalars['String'];
  section?: InputMaybe<Scalars['String']>;
  serviceDescription: Scalars['String'];
  state: Scalars['String'];
  survey?: InputMaybe<Scalars['String']>;
  taxableServices: Scalars['Boolean'];
  township?: InputMaybe<Scalars['String']>;
  wo?: InputMaybe<Scalars['String']>;
};

export type EditRequestedCustomerArgsInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  adminNotes?: InputMaybe<Scalars['String']>;
  attn?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country?: InputMaybe<Scalars['String']>;
  createCustomerRequestId: Scalars['String'];
  fax?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type EditRollupInvoiceCommand = {
  invoiceNumber: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
};

export type EeCodeMutationModel = {
  __typename?: 'EeCodeMutationModel';
  updateActive: ValidationResponse;
  updateOfficeOverheadEeCode: ValidationResponse;
  updateStateOverheadEeCode: ValidationResponse;
  upsertEeCode: ValidationResponse;
};


export type EeCodeMutationModelUpdateActiveArgs = {
  input: UpdateEeCodeActiveCommand;
};


export type EeCodeMutationModelUpdateOfficeOverheadEeCodeArgs = {
  input: UpdateOfficeOverheadEeCodeCommand;
};


export type EeCodeMutationModelUpdateStateOverheadEeCodeArgs = {
  input: UpdateStateOverheadEeCodeCommand;
};


export type EeCodeMutationModelUpsertEeCodeArgs = {
  input: UpsertEeCodeCommand;
};

export enum ElectronicInvoicingSystem {
  Actian = 'Actian',
  Ariba = 'Ariba',
  OpenInvoice = 'OpenInvoice',
  SmartGep = 'SmartGEP'
}

export type Employee = {
  __typename?: 'Employee';
  address1: Scalars['String'];
  address2: Scalars['String'];
  city: Scalars['String'];
  defaultDrive?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  employeeId: Scalars['Int'];
  fieldOfficeName?: Maybe<Scalars['String']>;
  finalPayroll?: Maybe<Scalars['LocalDate']>;
  firstName: Scalars['String'];
  fullPath: Scalars['String'];
  isMobileEmployee: Scalars['Boolean'];
  isTerminated: Scalars['Boolean'];
  lastName: Scalars['String'];
  middleInitial: Scalars['String'];
  payPeriod: PayPeriod;
  payrollAdminId?: Maybe<Scalars['Int']>;
  phone: Scalars['String'];
  state: Scalars['String'];
  timeEntryMethod: Scalars['String'];
  ultiProId: Scalars['String'];
  userPrincipalName: Scalars['String'];
  workLocation: Scalars['String'];
  zip: Scalars['String'];
};

export type EmployeeRatesMutationModel = {
  __typename?: 'EmployeeRatesMutationModel';
  createRate: ValidationResponse;
  deleteRate: ValidationResponse;
  editRate: ValidationResponse;
};


export type EmployeeRatesMutationModelCreateRateArgs = {
  input: CreateEmployeeRateCommand;
};


export type EmployeeRatesMutationModelDeleteRateArgs = {
  input: DeleteEmployeeRateCommand;
};


export type EmployeeRatesMutationModelEditRateArgs = {
  input: EditEmployeeRateCommand;
};

export type EogAfeType = {
  __typename?: 'EogAfeType';
  afeType: Scalars['String'];
  description: Scalars['String'];
  gen: Scalars['String'];
  sub: Scalars['String'];
};

export type EogAfeTypeMutationInput = {
  afeType: Scalars['String'];
  gen: Scalars['String'];
  sub: Scalars['String'];
};

export type EogAfeTypesQueryModel = {
  __typename?: 'EogAfeTypesQueryModel';
  all: Array<EogAfeType>;
};

export type ExistingCustomerArgsInput = {
  existingNumber: Scalars['String'];
};

export type ExistingGroupedFolderArgsInput = {
  groupedFolderId: Scalars['Int'];
};

export type ExpenseBase = IExpense & {
  __typename?: 'ExpenseBase';
  billableAmount?: Maybe<Scalars['Decimal']>;
  date: Scalars['LocalDate'];
  eeCode: Scalars['String'];
  expenseAccount?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  glAccount?: Maybe<Scalars['String']>;
  history: Array<ExpenseHistoryItem>;
  id: Scalars['String'];
  importEdited: Scalars['Boolean'];
  invoiceLabel?: Maybe<Scalars['String']>;
  lastAdminNotes?: Maybe<Scalars['String']>;
  location: StateCounty;
  notes?: Maybe<Scalars['String']>;
  payable: Payable;
  payableAmount: Scalars['Decimal'];
  payableOverridden: Scalars['Boolean'];
  projectId: Scalars['Int'];
  rateName: Scalars['String'];
  rateSheetName: Scalars['String'];
};

export type ExpenseHistoryItem = {
  __typename?: 'ExpenseHistoryItem';
  createdBy: Scalars['String'];
  createdOn: Scalars['Instant'];
  details: Array<Scalars['String']>;
  eventType: Scalars['String'];
  expenseId: Scalars['String'];
};

export type ExpenseRateSheet = {
  __typename?: 'ExpenseRateSheet';
  allowAssignment: Scalars['Boolean'];
  archived: Scalars['Boolean'];
  endDate?: Maybe<Scalars['LocalDate']>;
  id: Scalars['Int'];
  lastUsed?: Maybe<Scalars['LocalDate']>;
  name: Scalars['String'];
};

export type ExpenseRateSheetAssignment = {
  __typename?: 'ExpenseRateSheetAssignment';
  effectiveDate: Scalars['LocalDate'];
  rateSheet: ExpenseRateSheet;
};

export type FeatureFlagSettings = {
  __typename?: 'FeatureFlagSettings';
  maintenance: Scalars['Boolean'];
  newProjectChargeEditor: Scalars['Boolean'];
  productCatalog: Scalars['Boolean'];
  projectFolders: Scalars['Boolean'];
};

export type FieldOffice = {
  __typename?: 'FieldOffice';
  allowsProjects: Scalars['Boolean'];
  officeCode: Scalars['String'];
};

export type FieldOfficeMutationModel = {
  __typename?: 'FieldOfficeMutationModel';
  addProjectRequestReviewer: ValidationResponse;
  removeProjectRequestReviewer: ValidationResponse;
  updateProjectAffinity: ValidationResponse;
};


export type FieldOfficeMutationModelAddProjectRequestReviewerArgs = {
  input: AddProjectRequestReviewerCommand;
};


export type FieldOfficeMutationModelRemoveProjectRequestReviewerArgs = {
  input: RemoveProjectRequestReviewerCommand;
};


export type FieldOfficeMutationModelUpdateProjectAffinityArgs = {
  input: UpdateFieldOfficeProjectAffinityCommand;
};

export type FuelExpense = IExpense & {
  __typename?: 'FuelExpense';
  billableAmount?: Maybe<Scalars['Decimal']>;
  companyVehicle: Scalars['Boolean'];
  date: Scalars['LocalDate'];
  eeCode: Scalars['String'];
  expenseAccount?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  glAccount?: Maybe<Scalars['String']>;
  history: Array<ExpenseHistoryItem>;
  id: Scalars['String'];
  importEdited: Scalars['Boolean'];
  invoiceLabel?: Maybe<Scalars['String']>;
  lastAdminNotes?: Maybe<Scalars['String']>;
  location: StateCounty;
  notes?: Maybe<Scalars['String']>;
  odometer: Scalars['Decimal'];
  payable: Payable;
  payableAmount: Scalars['Decimal'];
  payableOverridden: Scalars['Boolean'];
  payerInformation: PayerInformation;
  projectId: Scalars['Int'];
  quantity: Scalars['Decimal'];
  rateName: Scalars['String'];
  rateSheetName: Scalars['String'];
  receiptImageId?: Maybe<Scalars['String']>;
  receiptImageUrl?: Maybe<Scalars['String']>;
  receiptTotal: Scalars['Decimal'];
  vehicleNumber: Scalars['String'];
};

export type FuelExpenseRate = IExpenseRate & {
  __typename?: 'FuelExpenseRate';
  billable: Scalars['Boolean'];
  expenseAccount?: Maybe<Scalars['String']>;
  glAccount?: Maybe<Scalars['String']>;
  invoiceLabel?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  unit?: Maybe<RateUnit>;
};

export enum GovernmentFundingType {
  None = 'None',
  Federal = 'Federal',
  State = 'State',
  County = 'County',
  City = 'City'
}

export type GroupedFolder = {
  __typename?: 'GroupedFolder';
  currentFolderPath: Scalars['String'];
  fullPath: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  projectNumbers?: Maybe<Array<Scalars['Int']>>;
  syncErrorMessage?: Maybe<Scalars['String']>;
  syncStatus: SyncStatus;
  targetFolderPath?: Maybe<Scalars['String']>;
};

export type GroupedFoldersQueryInput = {
  customerId: Scalars['Int'];
};

export type HelpRequestCommand = {
  issue: Scalars['String'];
  paths: Array<Scalars['String']>;
};

export type HelpRequestMutationModel = {
  __typename?: 'HelpRequestMutationModel';
  sendRequest: ValidationResponse;
};


export type HelpRequestMutationModelSendRequestArgs = {
  input: HelpRequestCommand;
};

export type IExpense = {
  billableAmount?: Maybe<Scalars['Decimal']>;
  date: Scalars['LocalDate'];
  eeCode: Scalars['String'];
  expenseAccount?: Maybe<Scalars['String']>;
  glAccount?: Maybe<Scalars['String']>;
  history: Array<ExpenseHistoryItem>;
  id: Scalars['String'];
  invoiceLabel?: Maybe<Scalars['String']>;
  lastAdminNotes?: Maybe<Scalars['String']>;
  location: StateCounty;
  notes?: Maybe<Scalars['String']>;
  payable: Payable;
  payableAmount: Scalars['Decimal'];
  payableOverridden: Scalars['Boolean'];
  rateName: Scalars['String'];
  rateSheetName: Scalars['String'];
};

export type IExpenseRate = {
  expenseAccount?: Maybe<Scalars['String']>;
  glAccount?: Maybe<Scalars['String']>;
  invoiceLabel?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  unit?: Maybe<RateUnit>;
};

export type Invoice = {
  __typename?: 'Invoice';
  actualEndDate?: Maybe<Scalars['LocalDate']>;
  afe?: Maybe<Scalars['String']>;
  billedBy?: Maybe<Employee>;
  billingAdmin: Employee;
  billingAdminId: Scalars['Int'];
  budget?: Maybe<Scalars['Decimal']>;
  canCancel: Scalars['Boolean'];
  cancelledDate?: Maybe<Scalars['LocalDate']>;
  canEdit: Scalars['Boolean'];
  canPostToRollup: Scalars['Boolean'];
  canRecall: Scalars['Boolean'];
  clientContactName: Scalars['String'];
  corpLocationId: Scalars['String'];
  costCenter?: Maybe<Scalars['String']>;
  county: Scalars['String'];
  customerName: Scalars['String'];
  customerNumber: Scalars['String'];
  customRollupInvoice?: Maybe<CustomRollupInvoice>;
  divisionId: Scalars['String'];
  eeCode: Scalars['String'];
  invoiceDate?: Maybe<Scalars['LocalDate']>;
  invoiceNumber: Scalars['String'];
  lineItems: Array<InvoiceLineItem>;
  locationState: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  officeCode: Scalars['String'];
  pdfDownloadUrl: Scalars['String'];
  po?: Maybe<Scalars['String']>;
  project: Project;
  projectManager: Employee;
  projectManagerId: Scalars['Int'];
  projectName: Scalars['String'];
  projectNumber: Scalars['Int'];
  state: InvoiceState;
  taxDescription: Scalars['String'];
  taxRate: Scalars['Decimal'];
  total: Scalars['Decimal'];
  totalTax: Scalars['Decimal'];
  wo?: Maybe<Scalars['String']>;
};

export enum InvoiceFilterState {
  Any = 'Any',
  Draft = 'Draft',
  Billed = 'Billed',
  Cancelled = 'Cancelled'
}

export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem';
  billable: Scalars['Boolean'];
  date: Scalars['LocalDate'];
  id: Scalars['Int'];
  invoiceNumber: Scalars['String'];
  label: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  projectCharge: ProjectCharge;
  projectChargeId: Scalars['Int'];
  quantity: Scalars['Decimal'];
  rate: Scalars['Decimal'];
  rebill: LineItemRebillInfo;
  taxable: Scalars['Boolean'];
};

export enum InvoiceState {
  Draft = 'Draft',
  Billed = 'Billed',
  Cancelled = 'Cancelled'
}

export type IProjectChargeHistoryItem = {
  changedBy: Scalars['String'];
  changedOn: Scalars['Instant'];
  event: Scalars['String'];
};

export type LegacyAuthorizations = {
  __typename?: 'LegacyAuthorizations';
  administerOverheadProjectCharges: Scalars['Boolean'];
  administerProjectCharges: Scalars['Boolean'];
  approveChargeAdjustments: Scalars['Boolean'];
  approveCharges: Scalars['Boolean'];
  approveThirdPartyInvoices: Scalars['Boolean'];
  cancelInvoices: Scalars['Boolean'];
  changeProjectCustomer: Scalars['Boolean'];
  createProject: Scalars['Boolean'];
  createThirdPartyInvoices: Scalars['Boolean'];
  editCustomerElectronicInvoicing: Scalars['Boolean'];
  editImportedExpenses: Scalars['Boolean'];
  editProjectCharges: Scalars['Boolean'];
  isMobileEmployee: Scalars['Boolean'];
  manageBadDebtWriteOffs: Scalars['Boolean'];
  manageCorpLocations: Scalars['Boolean'];
  manageDivisions: Scalars['Boolean'];
  manageRateSheets: Scalars['Boolean'];
  manageServiceDescriptions: Scalars['Boolean'];
  manageThirdPartyInvoiceConfig: Scalars['Boolean'];
  pmApprove: Scalars['Boolean'];
  psApprove: Scalars['Boolean'];
  requestCustomer: Scalars['Boolean'];
  requestProject: Scalars['Boolean'];
  reviewAssignedOfficeProjectRequests: Scalars['Boolean'];
  reviewProjectRequests: Scalars['Boolean'];
  reviewWorkData: Scalars['Boolean'];
  reviewWorkWeeks: Scalars['Boolean'];
  updateEmployeeFieldOffice: Scalars['Boolean'];
  updateFinalPayroll: Scalars['Boolean'];
  updateRoles: Scalars['Boolean'];
  usesWorkflowTimeEntry: Scalars['Boolean'];
  viewCustomer: Scalars['Boolean'];
  viewInvoices: Scalars['Boolean'];
  viewOverheadCharges: Scalars['Boolean'];
  viewPayrollAdminData: Scalars['Boolean'];
  viewPerformanceStats: Scalars['Boolean'];
  viewProjectStatus: Scalars['Boolean'];
  viewRevenueReports: Scalars['Boolean'];
  viewWorkData: Scalars['Boolean'];
};

export type LineItemRebillInfo = {
  __typename?: 'LineItemRebillInfo';
  rebilledFromInvoice?: Maybe<Scalars['String']>;
  rebilledOnInvoice?: Maybe<Scalars['String']>;
};

export type LogSessionDataCommand = {
  expirationTimestamp: Scalars['String'];
  sessionLength: Scalars['Duration'];
  version: Scalars['String'];
};

export type MarkProjectChargesBillableCommand = {
  billable: Scalars['Boolean'];
  editNotes: Scalars['String'];
  projectCharges: Array<Scalars['Int']>;
};

export type MarkProjectChargesTaxableCommand = {
  projectCharges: Array<Scalars['Int']>;
  taxable: Scalars['Boolean'];
};

export type MarkReadCommand = {
  notificationId: Scalars['String'];
};

export enum MenuAuthorizations {
  None = 'None',
  Impersonate = 'Impersonate',
  Rates = 'Rates',
  Customers = 'Customers',
  Expenses = 'Expenses',
  FieldOffices = 'FieldOffices',
  Invoices = 'Invoices',
  EeCodes = 'EeCodes',
  PendingCustomers = 'PendingCustomers',
  Projects = 'Projects',
  ProjectCharges = 'ProjectCharges',
  SalesTaxReport = 'SalesTaxReport',
  TimesheetReview = 'TimesheetReview',
  CorporateStructure = 'CorporateStructure',
  ProjectRequests = 'ProjectRequests',
  RequestNewProject = 'RequestNewProject',
  CreateNewProject = 'CreateNewProject',
  EmployeeRoles = 'EmployeeRoles',
  OfficeBillingReport = 'OfficeBillingReport',
  PerformanceStats = 'PerformanceStats',
  RevenueReports = 'RevenueReports',
  Products = 'Products',
  Employees = 'Employees',
  ThirdPartyInvoices = 'ThirdPartyInvoices',
  ViewProjectStatus = 'ViewProjectStatus',
  UnbilledProjectCharges = 'UnbilledProjectCharges',
  EditProject = 'EditProject',
  ViewAllProjectFolders = 'ViewAllProjectFolders',
  NewProjectChargeEditor = 'NewProjectChargeEditor',
  ViewProjectFolders = 'ViewProjectFolders',
  OverrideRate = 'OverrideRate',
  TrainingReports = 'TrainingReports',
  AdministrateFolders = 'AdministrateFolders',
  DailyProjectExport = 'DailyProjectExport'
}

export type MileageExpense = IExpense & {
  __typename?: 'MileageExpense';
  beginningOdometer: Scalars['Decimal'];
  billableAmount?: Maybe<Scalars['Decimal']>;
  companyVehicle: Scalars['Boolean'];
  date: Scalars['LocalDate'];
  eeCode: Scalars['String'];
  endingOdometer: Scalars['Decimal'];
  expenseAccount?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  glAccount?: Maybe<Scalars['String']>;
  history: Array<ExpenseHistoryItem>;
  id: Scalars['String'];
  importEdited: Scalars['Boolean'];
  invoiceLabel?: Maybe<Scalars['String']>;
  lastAdminNotes?: Maybe<Scalars['String']>;
  location: StateCounty;
  mileage: Scalars['Decimal'];
  notes?: Maybe<Scalars['String']>;
  payable: Payable;
  payableAmount: Scalars['Decimal'];
  payableOverridden: Scalars['Boolean'];
  projectId: Scalars['Int'];
  rate: Scalars['Decimal'];
  rateName: Scalars['String'];
  rateSheetName: Scalars['String'];
  vehicleNumber: Scalars['String'];
};

export type MileageExpenseRate = IExpenseRate & {
  __typename?: 'MileageExpenseRate';
  billableAmountPerMile?: Maybe<Scalars['Decimal']>;
  expenseAccount?: Maybe<Scalars['String']>;
  glAccount?: Maybe<Scalars['String']>;
  invoiceLabel?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  reimbursableAmountPerMile: Scalars['Decimal'];
  unit?: Maybe<RateUnit>;
};

export type MobileAllowanceExpense = IExpense & {
  __typename?: 'MobileAllowanceExpense';
  billableAmount?: Maybe<Scalars['Decimal']>;
  date: Scalars['LocalDate'];
  eeCode: Scalars['String'];
  expenseAccount?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  glAccount?: Maybe<Scalars['String']>;
  history: Array<ExpenseHistoryItem>;
  id: Scalars['String'];
  importEdited: Scalars['Boolean'];
  invoiceLabel?: Maybe<Scalars['String']>;
  lastAdminNotes?: Maybe<Scalars['String']>;
  location: StateCounty;
  notes?: Maybe<Scalars['String']>;
  payable: Payable;
  payableAmount: Scalars['Decimal'];
  payableOverridden: Scalars['Boolean'];
  projectId: Scalars['Int'];
  quantity: Scalars['Int'];
  rateName: Scalars['String'];
  rateSheetName: Scalars['String'];
};

export type MobileAllowanceExpenseRate = IExpenseRate & {
  __typename?: 'MobileAllowanceExpenseRate';
  billableAmount?: Maybe<Scalars['Decimal']>;
  expenseAccount?: Maybe<Scalars['String']>;
  glAccount?: Maybe<Scalars['String']>;
  invoiceLabel?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  quantity: Scalars['Int'];
  reimbursableAmount: Scalars['Decimal'];
  unit?: Maybe<RateUnit>;
};

export type MutationModel = {
  __typename?: 'MutationModel';
  corpLocations: CorpLocationMutationModel;
  customers: CustomerMutationModel;
  customRollupInvoices: CustomRollupInvoiceMutationModel2;
  divisions: DivisionMutationModel;
  eeCodes: EeCodeMutationModel;
  employeeRates: EmployeeRatesMutationModel;
  fieldOffices: FieldOfficeMutationModel;
  helpRequest: HelpRequestMutationModel;
  notifications: AppNotificationMutationModel;
  perDiemRates: PerDiemRatesMutationModel;
  products: ProductMutationModel;
  projectCharges: ProjectChargesMutationModel;
  projectFolders: ProjectFoldersMutationModel;
  projectRequests: ProjectRequestMutationModel;
  search: SearchMutationModel;
  serviceDescriptions: ServiceDescriptionMutationModel;
  users: UsersMutationModel;
};

export type NewCustomerArgsInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  adminNotes?: InputMaybe<Scalars['String']>;
  attn?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type NewGroupedFolderArgsInput = {
  driveLetter: Scalars['String'];
  name: Scalars['String'];
};

export type NotificationsResult = {
  __typename?: 'NotificationsResult';
  count: Scalars['Int'];
  notifications: Array<AppNotification>;
};

export type OfficeBillingAmount = {
  __typename?: 'OfficeBillingAmount';
  amount: Scalars['Decimal'];
  officeCode: Scalars['String'];
};

export type OfficeBillingMonthRow = {
  __typename?: 'OfficeBillingMonthRow';
  amounts: Array<OfficeBillingAmount>;
  month: Scalars['Int'];
  total: Scalars['Decimal'];
};

export type OfficeBillingQueryModel = {
  __typename?: 'OfficeBillingQueryModel';
  currentYearSummary?: Maybe<OfficeBillingSummary>;
};

export type OfficeBillingSummary = {
  __typename?: 'OfficeBillingSummary';
  months: Array<OfficeBillingMonthRow>;
  officeCodes: Array<Scalars['String']>;
  year: Scalars['Int'];
  yearToDate: OfficeBillingTotalsRow;
};

export type OfficeBillingTotalsRow = {
  __typename?: 'OfficeBillingTotalsRow';
  amounts: Array<OfficeBillingAmount>;
  total: Scalars['Decimal'];
};

export type OverrideCustomerFolderSyncCommand = {
  folderId: Scalars['Int'];
  path: Scalars['String'];
  retrySync: Scalars['Boolean'];
};

export type OverrideGroupedFolderSyncCommand = {
  groupedFolderId: Scalars['Int'];
  name: Scalars['String'];
  retrySync: Scalars['Boolean'];
};

export type OverrideProjectFolderSyncCommand = {
  name: Scalars['String'];
  projectNumber: Scalars['Int'];
  retrySync: Scalars['Boolean'];
};

export enum Payable {
  Payroll = 'Payroll',
  Reimbursement = 'Reimbursement',
  None = 'None',
  Invoice = 'Invoice'
}

export type PayBadDebtCommand = {
  amount: Scalars['Decimal'];
  badDebtWriteOffId: Scalars['Int'];
  customerNumber: Scalars['String'];
  date: Scalars['LocalDate'];
};

export enum PayerInformation {
  Company = 'Company',
  Employee = 'Employee'
}

export enum PayPeriod {
  Weekly = 'Weekly',
  Biweekly = 'Biweekly'
}

export type PendingCustomer = {
  __typename?: 'PendingCustomer';
  address1: Scalars['String'];
  address2: Scalars['String'];
  adminNotes?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  createCustomerRequestId: Scalars['UUID'];
  name: Scalars['String'];
  nmTaxable: Scalars['Boolean'];
  phone: Scalars['String'];
  requester?: Maybe<Employee>;
  requesterId?: Maybe<Scalars['Int']>;
  state: Scalars['String'];
  subAccountOf?: Maybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type PendingCustomerArgsInput = {
  pendingRequestId: Scalars['String'];
};

export type PerDiemExpense = IExpense & {
  __typename?: 'PerDiemExpense';
  billableAmount?: Maybe<Scalars['Decimal']>;
  date: Scalars['LocalDate'];
  eeCode: Scalars['String'];
  expenseAccount?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  glAccount?: Maybe<Scalars['String']>;
  history: Array<ExpenseHistoryItem>;
  id: Scalars['String'];
  importEdited: Scalars['Boolean'];
  invoiceLabel?: Maybe<Scalars['String']>;
  kind: PerDiemKind;
  lastAdminNotes?: Maybe<Scalars['String']>;
  location: StateCounty;
  notes?: Maybe<Scalars['String']>;
  payable: Payable;
  payableAmount: Scalars['Decimal'];
  payableOverridden: Scalars['Boolean'];
  projectId: Scalars['Int'];
  quantity: Scalars['Int'];
  rateName: Scalars['String'];
  rateSheetName: Scalars['String'];
  receiptImageId?: Maybe<Scalars['String']>;
  receiptImageUrl?: Maybe<Scalars['String']>;
};

export type PerDiemExpenseRate = IExpenseRate & {
  __typename?: 'PerDiemExpenseRate';
  billableOverride?: Maybe<Scalars['Decimal']>;
  expenseAccount?: Maybe<Scalars['String']>;
  glAccount?: Maybe<Scalars['String']>;
  invoiceLabel?: Maybe<Scalars['String']>;
  kind: PerDiemKind;
  name: Scalars['String'];
  quantity: Scalars['Int'];
  unit?: Maybe<RateUnit>;
};

export enum PerDiemKind {
  Meals = 'Meals',
  Lodging = 'Lodging',
  Travel = 'Travel',
  TravelMeals = 'TravelMeals'
}

export type PerDiemRatesMutationModel = {
  __typename?: 'PerDiemRatesMutationModel';
  create: ValidationResponse;
};


export type PerDiemRatesMutationModelCreateArgs = {
  input: AddRatesCommand;
};

export type PmApproveProjectChargesCommand = {
  projectCharges: Array<Scalars['Int']>;
};

export type PreviousNameHistoryItem = {
  __typename?: 'PreviousNameHistoryItem';
  changedBy?: Maybe<Scalars['String']>;
  changedOn?: Maybe<Scalars['LocalDate']>;
  name: Scalars['String'];
};

export enum PriceClassification {
  Fixed = 'Fixed',
  Variable = 'Variable',
  PerDiem = 'PerDiem',
  EmployeeRate = 'EmployeeRate'
}

export type Product = {
  __typename?: 'Product';
  classification: PriceClassification;
  id: Scalars['Int'];
  name: Scalars['String'];
  perDiemKind?: Maybe<PerDiemKind>;
  rates: Array<ProductRate>;
  unit: ProductUnit;
};

export type ProductMutationModel = {
  __typename?: 'ProductMutationModel';
  addProductRate: ValidationResponse;
  createProduct: ValidationResponse;
  renameProduct: ValidationResponse;
};


export type ProductMutationModelAddProductRateArgs = {
  input: AddProductRateCommand;
};


export type ProductMutationModelCreateProductArgs = {
  input: CreateProductCommand;
};


export type ProductMutationModelRenameProductArgs = {
  input: RenameProductCommand;
};

export type ProductQueryModel = {
  __typename?: 'ProductQueryModel';
  all: Array<Product>;
};

export type ProductRate = {
  __typename?: 'ProductRate';
  amount?: Maybe<Scalars['Decimal']>;
  id: Scalars['Int'];
  productId: Scalars['Int'];
};

export enum ProductUnit {
  Hourly = 'Hourly',
  Day = 'Day',
  Each = 'Each',
  Foot = 'Foot',
  Mile = 'Mile',
  Gallon = 'Gallon'
}

export type Project = {
  __typename?: 'Project';
  actualEndDate?: Maybe<Scalars['LocalDate']>;
  actualStartDate?: Maybe<Scalars['LocalDate']>;
  afe?: Maybe<Scalars['String']>;
  allowThirdPartyInvoice: Scalars['Boolean'];
  billingAdmin: Employee;
  billingFrequency: BillingFrequencyType;
  block?: Maybe<Scalars['String']>;
  budget?: Maybe<Scalars['Decimal']>;
  callerName: Scalars['String'];
  canAddCharge: Scalars['Boolean'];
  canCreateInvoice: Scalars['Boolean'];
  canEdit: Scalars['Boolean'];
  canViewInvoices: Scalars['Boolean'];
  certifiedPayroll: Scalars['Boolean'];
  changedOn?: Maybe<Scalars['Instant']>;
  city: Scalars['String'];
  clientContactName: Scalars['String'];
  contractNumber?: Maybe<Scalars['String']>;
  corpLocation: CorpLocation;
  costCenter?: Maybe<Scalars['String']>;
  createdOn: Scalars['LocalDate'];
  customer: Customer;
  dateIn: Scalars['LocalDate'];
  description: Scalars['String'];
  division: Division;
  eogAfeType?: Maybe<EogAfeType>;
  estimatedEndDate?: Maybe<Scalars['LocalDate']>;
  estimatedStartDate?: Maybe<Scalars['LocalDate']>;
  expenseRateSheets: Array<ExpenseRateSheetAssignment>;
  geographicLocation: Scalars['String'];
  glCode?: Maybe<Scalars['String']>;
  governmentFunding: GovernmentFundingType;
  groupedFolder?: Maybe<GroupedFolder>;
  internalNotes: Scalars['String'];
  invoiceNotes: Scalars['String'];
  latitude?: Maybe<Scalars['Decimal']>;
  legacy: Scalars['Boolean'];
  legacyBilled: Scalars['Decimal'];
  location: StateCounty;
  longitude?: Maybe<Scalars['Decimal']>;
  name: Scalars['String'];
  networkPath?: Maybe<Scalars['String']>;
  number: Scalars['Int'];
  officeCode: Scalars['String'];
  originalName: Scalars['String'];
  po?: Maybe<Scalars['String']>;
  previousNames: Array<PreviousNameHistoryItem>;
  projectFolder?: Maybe<ProjectFolder>;
  projectGroup?: Maybe<ProjectGroup>;
  projectManager: Employee;
  projectOrigination: ProjectOrigination;
  projectOriginationName?: Maybe<Scalars['String']>;
  projectRequestApprover?: Maybe<Employee>;
  projectSupervisor: Employee;
  publishDate?: Maybe<Scalars['Instant']>;
  range?: Maybe<Scalars['String']>;
  requisitioner?: Maybe<Scalars['String']>;
  scope: Scalars['String'];
  section?: Maybe<Scalars['String']>;
  serviceDescription: ServiceDescription;
  simplifiedName: Scalars['String'];
  stats: ProjectStats;
  status: ProjectStatus;
  survey?: Maybe<Scalars['String']>;
  taskRateSheets: Array<TaskRateSheetAssignment>;
  township?: Maybe<Scalars['String']>;
  wo?: Maybe<Scalars['String']>;
};

export type ProjectArgsInput = {
  projectNumber: Scalars['Int'];
};

export type ProjectCharge = {
  __typename?: 'ProjectCharge';
  billable: Scalars['Boolean'];
  canAdjust: Scalars['Boolean'];
  canBaApprove: Scalars['Boolean'];
  canEditBillable: Scalars['Boolean'];
  canEditDate: Scalars['Boolean'];
  canEditTaxable: Scalars['Boolean'];
  canMoveProject: Scalars['Boolean'];
  canOverrideRate: Scalars['Boolean'];
  canPmApprove: Scalars['Boolean'];
  canPostToInvoice: Scalars['Boolean'];
  canPsApprove: Scalars['Boolean'];
  canSplit: Scalars['Boolean'];
  date: Scalars['LocalDate'];
  eeCode: Scalars['String'];
  employee?: Maybe<Employee>;
  employeeId?: Maybe<Scalars['Int']>;
  expense?: Maybe<IExpense>;
  glAccount?: Maybe<Scalars['String']>;
  history: Array<IProjectChargeHistoryItem>;
  id: Scalars['Int'];
  isThirdParty: Scalars['Boolean'];
  label: Scalars['String'];
  lastEditNotes?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  project: Project;
  projectId: Scalars['Int'];
  projectTime?: Maybe<ProjectTimeEntry>;
  quantity?: Maybe<Scalars['Decimal']>;
  rate: Scalars['Decimal'];
  rateSheetName?: Maybe<Scalars['String']>;
  state: ProjectChargeState;
  taxable: Scalars['Boolean'];
  timesheetQuantity?: Maybe<Scalars['Decimal']>;
  total?: Maybe<Scalars['Decimal']>;
  type: ChargeType;
  unit?: Maybe<RateUnit>;
};

export type ProjectChargeHistoryItem = IProjectChargeHistoryItem & {
  __typename?: 'ProjectChargeHistoryItem';
  changedBy: Scalars['String'];
  changedOn: Scalars['Instant'];
  event: Scalars['String'];
};

export type ProjectChargeIndexStatusResponse = {
  __typename?: 'ProjectChargeIndexStatusResponse';
  isConverged: Scalars['Boolean'];
  maxVersion: Scalars['Int'];
  minVersion: Scalars['Int'];
  projectChargeCount: Scalars['Int'];
  rowsAtMaxVersion: Scalars['Int'];
  totalRows: Scalars['Int'];
};

export type ProjectChargesMutationModel = {
  __typename?: 'ProjectChargesMutationModel';
  baApprove: ValidationResponse;
  changeProject: ValidationResponse;
  createInvoiceCharge: CreateProjectChargeResponse;
  createProjectCharge: CreateProjectChargeResponse;
  editEeCode: ValidationResponse;
  editProjectCharge: ValidationResponse;
  markBillable: ValidationResponse;
  markTaxable: ValidationResponse;
  pmApprove: ValidationResponse;
  psApprove: ValidationResponse;
  splitCharge: SplitChargeResponse;
};


export type ProjectChargesMutationModelBaApproveArgs = {
  input: BaApproveProjectChargesCommand;
};


export type ProjectChargesMutationModelChangeProjectArgs = {
  input: ChangeProjectChargesProjectCommand;
};


export type ProjectChargesMutationModelCreateInvoiceChargeArgs = {
  input: CreateInvoiceChargeCommand;
};


export type ProjectChargesMutationModelCreateProjectChargeArgs = {
  input: CreateProjectChargeCommand;
};


export type ProjectChargesMutationModelEditEeCodeArgs = {
  input: EditProjectChargesEeCodeCommand;
};


export type ProjectChargesMutationModelEditProjectChargeArgs = {
  input: EditProjectChargeCommand;
};


export type ProjectChargesMutationModelMarkBillableArgs = {
  input: MarkProjectChargesBillableCommand;
};


export type ProjectChargesMutationModelMarkTaxableArgs = {
  input: MarkProjectChargesTaxableCommand;
};


export type ProjectChargesMutationModelPmApproveArgs = {
  input: PmApproveProjectChargesCommand;
};


export type ProjectChargesMutationModelPsApproveArgs = {
  input: PsApproveProjectChargesCommand;
};


export type ProjectChargesMutationModelSplitChargeArgs = {
  input: SplitChargeCommand;
};

export enum ProjectChargeState {
  Archived = 'Archived',
  Cancelled = 'Cancelled',
  PmPending = 'PmPending',
  PsPending = 'PsPending',
  BaPending = 'BaPending',
  PostPending = 'PostPending',
  PostedNotBilled = 'PostedNotBilled',
  Billed = 'Billed',
  PrPending = 'PrPending'
}

export type ProjectFolder = {
  __typename?: 'ProjectFolder';
  currentFolderPath: Scalars['String'];
  fullPath: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  projectId: Scalars['Int'];
  syncErrorMessage?: Maybe<Scalars['String']>;
  syncStatus: SyncStatus;
  targetFolderPath?: Maybe<Scalars['String']>;
};

export type ProjectFoldersMutationModel = {
  __typename?: 'ProjectFoldersMutationModel';
  addProjectToGroupedFolder: ValidationResponse;
  completeGroupedFolderMove: ValidationResponse;
  completeProjectFolderMove: ValidationResponse;
  create: ValidationResponse;
  createGroupedFolder: ValidationResponse;
  createGroupedFolderForProject: ValidationResponse;
  overrideCustomerFolderSync: ValidationResponse;
  overrideGroupedFolderSync: ValidationResponse;
  overrideProjectFolderSync: ValidationResponse;
  requestGroupedFolderMove: ValidationResponse;
  requestProjectFolderMove: ValidationResponse;
};


export type ProjectFoldersMutationModelAddProjectToGroupedFolderArgs = {
  input: AddProjectToGroupedFolderCommand;
};


export type ProjectFoldersMutationModelCompleteGroupedFolderMoveArgs = {
  input: CompleteGroupedFolderMoveCommand;
};


export type ProjectFoldersMutationModelCompleteProjectFolderMoveArgs = {
  input: CompleteProjectFolderMoveCommand;
};


export type ProjectFoldersMutationModelCreateArgs = {
  input: CreateProjectFolderCommand;
};


export type ProjectFoldersMutationModelCreateGroupedFolderArgs = {
  input: CreateGroupedFolderCommand;
};


export type ProjectFoldersMutationModelCreateGroupedFolderForProjectArgs = {
  input: CreateGroupedFolderForProjectCommand;
};


export type ProjectFoldersMutationModelOverrideCustomerFolderSyncArgs = {
  input: OverrideCustomerFolderSyncCommand;
};


export type ProjectFoldersMutationModelOverrideGroupedFolderSyncArgs = {
  input: OverrideGroupedFolderSyncCommand;
};


export type ProjectFoldersMutationModelOverrideProjectFolderSyncArgs = {
  input: OverrideProjectFolderSyncCommand;
};


export type ProjectFoldersMutationModelRequestGroupedFolderMoveArgs = {
  input: RequestGroupedFolderMoveCommand;
};


export type ProjectFoldersMutationModelRequestProjectFolderMoveArgs = {
  input: RequestProjectFolderMoveCommand;
};

export type ProjectFoldersQueryInput = {
  projectManager?: InputMaybe<Scalars['String']>;
};

export type ProjectFoldersQueryModel = {
  __typename?: 'ProjectFoldersQueryModel';
  drives: Array<SharedDrive>;
  folders: Array<StructuralFolder>;
  groupedFolders: Array<GroupedFolder>;
};


export type ProjectFoldersQueryModelFoldersArgs = {
  input: ProjectFoldersQueryInput;
};


export type ProjectFoldersQueryModelGroupedFoldersArgs = {
  input: GroupedFoldersQueryInput;
};

export type ProjectGroup = {
  __typename?: 'ProjectGroup';
  billingOffice?: Maybe<FieldOffice>;
  billingOfficeId?: Maybe<Scalars['Int']>;
  customer: Customer;
  customerId: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  projects: Array<Project>;
};

export type ProjectGroupArgsInput = {
  customerNumber: Scalars['String'];
  groupName: Scalars['String'];
};

export enum ProjectOrigination {
  /** BD - McBee */
  BdMcBee = 'BdMcBee',
  /** BD - Storozyszyn */
  BdStorozyszyn = 'BdStorozyszyn',
  /** BD - Shablo */
  BdShablo = 'BdShablo',
  /** BD - Lueders */
  BdLueders = 'BdLueders',
  /** Bid Publication Service */
  BidPublicationService = 'BidPublicationService',
  /** Civil Survey Department */
  CivilSurveyDepartment = 'CivilSurveyDepartment',
  /** Construction Department */
  ConstructionDepartment = 'ConstructionDepartment',
  /** Engineering Department */
  EngineeringDepartment = 'EngineeringDepartment',
  /** Environmental Department */
  EnvironmentalDepartment = 'EnvironmentalDepartment',
  /** Existing Customer */
  ExistingCustomer = 'ExistingCustomer',
  /** Event */
  Event = 'Event',
  /** Facebook */
  Facebook = 'Facebook',
  /** Geospatial Department */
  GeospatialDepartment = 'GeospatialDepartment',
  /** Google */
  Google = 'Google',
  /** Instagram */
  Instragram = 'Instragram',
  /** Referral */
  Referral = 'Referral',
  /** Survey Department */
  SurveyDepartment = 'SurveyDepartment',
  /** Topographic Website */
  TopographicWebsite = 'TopographicWebsite',
  /** Unset */
  Unset = 'Unset'
}

export type ProjectRequestCustomerArgsInput = {
  editRequestedCustomer?: InputMaybe<EditRequestedCustomerArgsInput>;
  existingCustomerArgs?: InputMaybe<ExistingCustomerArgsInput>;
  newCustomer?: InputMaybe<NewCustomerArgsInput>;
  pendingCustomerArgs?: InputMaybe<PendingCustomerArgsInput>;
};

export type ProjectRequestFolderArgsInput = {
  existingGroupedFolderArgs?: InputMaybe<ExistingGroupedFolderArgsInput>;
  newGroupedFolderArgs?: InputMaybe<NewGroupedFolderArgsInput>;
  singleProjectFolderArgs?: InputMaybe<SingleProjectFolderArgsInput>;
};

export type ProjectRequestMutationModel = {
  __typename?: 'ProjectRequestMutationModel';
  approveGroup: ValidationResponse;
  checkout: ValidationResponse;
  create: CreateProjectRequestResponse;
  edit: ValidationResponse;
  editGroupCustomer: ValidationResponse;
  editGroupOffice: ValidationResponse;
  reject: ValidationResponse;
  ungroup: ValidationResponse;
};


export type ProjectRequestMutationModelApproveGroupArgs = {
  input: ApproveRequestGroupCommand;
};


export type ProjectRequestMutationModelCheckoutArgs = {
  input: CheckoutProjectRequestGroupCommand;
};


export type ProjectRequestMutationModelCreateArgs = {
  input: CreateProjectRequestCommand;
};


export type ProjectRequestMutationModelEditArgs = {
  input: EditProjectRequestCommand;
};


export type ProjectRequestMutationModelEditGroupCustomerArgs = {
  input: EditGroupCustomerCommand;
};


export type ProjectRequestMutationModelEditGroupOfficeArgs = {
  input: EditGroupOfficeCommand;
};


export type ProjectRequestMutationModelRejectArgs = {
  input: RejectProjectRequestCommand;
};


export type ProjectRequestMutationModelUngroupArgs = {
  input: UngroupCommand;
};

export type ProjectsQueryModel = {
  __typename?: 'ProjectsQueryModel';
  project?: Maybe<Project>;
};


export type ProjectsQueryModelProjectArgs = {
  input: ProjectArgsInput;
};

export type ProjectStats = {
  __typename?: 'ProjectStats';
  chargesAwaitingApproval: Scalars['Int'];
  chargesBilled: Scalars['Int'];
  chargesPendingBilling: Scalars['Int'];
  chargesUnbilled: Scalars['Int'];
  chargesUnreviewed: Scalars['Int'];
  lastChargeDate?: Maybe<Scalars['LocalDate']>;
  lastInvoiceDate?: Maybe<Scalars['LocalDate']>;
  projectId: Scalars['Int'];
  totalBaPending: Scalars['Decimal'];
  totalBilled: Scalars['Decimal'];
  totalBilledWithoutTax: Scalars['Decimal'];
  totalChargesUnapproved: Scalars['Int'];
  totalNonBillable: Scalars['Decimal'];
  totalPendingApproval: Scalars['Decimal'];
  totalPendingBilling: Scalars['Decimal'];
  totalPendingHours: Scalars['Decimal'];
  totalPmPending: Scalars['Decimal'];
  totalPostedNotBilled: Scalars['Decimal'];
  totalPostPending: Scalars['Decimal'];
  totalPrPending: Scalars['Decimal'];
  totalPsPending: Scalars['Decimal'];
  totalUnapproved: Scalars['Decimal'];
  totalUnbilled: Scalars['Decimal'];
  totalUnbilledHours: Scalars['Decimal'];
};

export enum ProjectStatus {
  Active = 'Active',
  Closed = 'Closed'
}

export type ProjectTimeDailyHours = {
  __typename?: 'ProjectTimeDailyHours';
  asBuilt: Scalars['Duration'];
  boundary: Scalars['Duration'];
  clStake: Scalars['Duration'];
  constRestake: Scalars['Duration'];
  constStake: Scalars['Duration'];
  employee: Employee;
  employeeId: Scalars['Int'];
  locate: Scalars['Duration'];
  rainoutOther: Scalars['Duration'];
  rerouteStake: Scalars['Duration'];
  role: ProjectTimeDailyRole;
  travelHours: Scalars['Duration'];
};

export enum ProjectTimeDailyRole {
  FieldSupervisor = 'FieldSupervisor',
  LeadPartyChief = 'LeadPartyChief',
  PartyChief = 'PartyChief',
  InstrumentTech = 'InstrumentTech',
  RodMan = 'RodMan'
}

export type ProjectTimeEntry = {
  __typename?: 'ProjectTimeEntry';
  certifiedPayroll: Scalars['Boolean'];
  crewSize: Scalars['Int'];
  dailyHours: Array<ProjectTimeDailyHours>;
  date: Scalars['LocalDate'];
  eeCode: Scalars['String'];
  employee: Employee;
  glAccount?: Maybe<Scalars['String']>;
  hours: Scalars['Duration'];
  id: Scalars['String'];
  lastAdminNotes?: Maybe<Scalars['String']>;
  location: StateCounty;
  myRole?: Maybe<CrewRole>;
  notes: Scalars['String'];
  otherCrew1?: Maybe<Employee>;
  otherCrew1Id?: Maybe<Scalars['Int']>;
  otherCrew2?: Maybe<Employee>;
  otherCrew2Id?: Maybe<Scalars['Int']>;
  otherRole1?: Maybe<CrewRole>;
  otherRole2?: Maybe<CrewRole>;
  pdfDownloadUrl: Scalars['String'];
  project: Project;
  projectId: Scalars['Int'];
  rate?: Maybe<Scalars['Decimal']>;
  rateSheetName: Scalars['String'];
  taskName: Scalars['String'];
  taskType: TaskRateType;
  taskUnit: TaskRateUnit;
  trainingUploadImageId?: Maybe<Scalars['UUID']>;
  trainingUploadImageUrl?: Maybe<Scalars['String']>;
};

export type PsApproveProjectChargesCommand = {
  projectCharges: Array<Scalars['Int']>;
};

export type QueryModel = {
  __typename?: 'QueryModel';
  authorization: AuthorizationQueryModel;
  corpLocations: CorpLocationQueryModel;
  customers: CustomersQueryModel2;
  customRollupInvoices: CustomRollupInvoiceQueryModel2;
  divisions: DivisionQueryModel;
  eogAfeTypeValues: EogAfeTypesQueryModel;
  notifications: AppNotificationQueryModel;
  officeBilling: OfficeBillingQueryModel;
  products: ProductQueryModel;
  projectFolders: ProjectFoldersQueryModel;
  projects: ProjectsQueryModel;
  search: SearchQueryModel;
  serviceDescriptions: ServiceDescriptionQueryModel;
  training: TrainingReportQueryModel;
};

export enum RateUnit {
  Hourly = 'Hourly',
  Day = 'Day',
  Each = 'Each',
  Foot = 'Foot',
  Mile = 'Mile',
  Gallon = 'Gallon'
}

export enum ReceiptValuedCategory {
  Automotive = 'Automotive',
  Lodging = 'Lodging',
  Meals = 'Meals',
  None = 'None'
}

export type ReceiptValuedExpense = IExpense & {
  __typename?: 'ReceiptValuedExpense';
  billableAmount?: Maybe<Scalars['Decimal']>;
  category: ReceiptValuedCategory;
  date: Scalars['LocalDate'];
  eeCode: Scalars['String'];
  expenseAccount?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  glAccount?: Maybe<Scalars['String']>;
  history: Array<ExpenseHistoryItem>;
  id: Scalars['String'];
  importEdited: Scalars['Boolean'];
  invoiceLabel?: Maybe<Scalars['String']>;
  lastAdminNotes?: Maybe<Scalars['String']>;
  location: StateCounty;
  notes?: Maybe<Scalars['String']>;
  odometer?: Maybe<Scalars['Decimal']>;
  payable: Payable;
  payableAmount: Scalars['Decimal'];
  payableOverridden: Scalars['Boolean'];
  payerInformation: PayerInformation;
  projectId: Scalars['Int'];
  rateName: Scalars['String'];
  rateSheetName: Scalars['String'];
  receiptImageId: Scalars['String'];
  receiptImageUrl: Scalars['String'];
  receiptTotal: Scalars['Decimal'];
  vehicleNumber?: Maybe<Scalars['String']>;
};

export type ReceiptValuedExpenseRate = IExpenseRate & {
  __typename?: 'ReceiptValuedExpenseRate';
  billable: Scalars['Boolean'];
  category: ReceiptValuedCategory;
  expenseAccount?: Maybe<Scalars['String']>;
  glAccount?: Maybe<Scalars['String']>;
  invoiceLabel?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  requiresLocation: Scalars['Boolean'];
  unit?: Maybe<RateUnit>;
};

export type RejectCustomerCommand = {
  createCustomerRequestId: Scalars['String'];
  reason: Scalars['String'];
};

export type RejectProjectRequestCommand = {
  reason: Scalars['String'];
  requestId: Scalars['String'];
};

export type RemoveProjectRequestReviewerCommand = {
  officeCode: Scalars['String'];
  userPrincipalName: Scalars['String'];
};

export type RemoveRollupInvoiceLineItemCommand = {
  customRollupInvoiceNumber: Scalars['String'];
  invoiceNumber: Scalars['String'];
};

export type RenameProductCommand = {
  name: Scalars['String'];
  productId: Scalars['Int'];
};

export type RequestGroupedFolderMoveCommand = {
  driveLetter: Scalars['String'];
  folderId: Scalars['Int'];
};

export type RequestProjectFolderMoveCommand = {
  driveLetter: Scalars['String'];
  folderId: Scalars['Int'];
};

export type SearchMutationModel = {
  __typename?: 'SearchMutationModel';
  startRebuildProjectChargeIndex: StartRebuildProjectChargeIndexResponse;
};


export type SearchMutationModelStartRebuildProjectChargeIndexArgs = {
  input: StartRebuildProjectChargeIndexCommand;
};

export type SearchQueryModel = {
  __typename?: 'SearchQueryModel';
  projectChargeIndexStatus?: Maybe<ProjectChargeIndexStatusResponse>;
};

export type ServiceDescription = {
  __typename?: 'ServiceDescription';
  description: Scalars['String'];
  displayName: Scalars['String'];
  industry: Scalars['String'];
  isActive: Scalars['Boolean'];
  isOverhead: Scalars['Boolean'];
  legacyWorkCode: Scalars['String'];
  projectType: Scalars['String'];
};

export type ServiceDescriptionMutationModel = {
  __typename?: 'ServiceDescriptionMutationModel';
  changeIsActive: ValidationResponse;
  update: ValidationResponse;
};


export type ServiceDescriptionMutationModelChangeIsActiveArgs = {
  input: ChangeServiceDescriptionActiveInput;
};


export type ServiceDescriptionMutationModelUpdateArgs = {
  input: UpdateServiceDescriptionInput;
};

export type ServiceDescriptionQueryModel = {
  __typename?: 'ServiceDescriptionQueryModel';
  all: Array<ServiceDescription>;
};

export type SharedDrive = {
  __typename?: 'SharedDrive';
  driveLetter: Scalars['String'];
  physicalLocation: Scalars['String'];
};

export type SingleCustomerInput = {
  customerNumber: Scalars['String'];
};

export type SingleProjectFolderArgsInput = {
  driveLetter: Scalars['String'];
};

export type SingleRollupInvoiceArgsInput = {
  invoiceNumber: Scalars['String'];
};

export type SplitChargeArgsInput = {
  label: Scalars['String'];
  notes: Scalars['String'];
  projectNumber: Scalars['Int'];
  quantity: Scalars['Decimal'];
  rate: Scalars['Decimal'];
  rateSheetName: Scalars['String'];
  taxable: Scalars['Boolean'];
};

export type SplitChargeCommand = {
  adminNotes: Scalars['String'];
  id: Scalars['Int'];
  label: Scalars['String'];
  notes: Scalars['String'];
  projectId?: InputMaybe<Scalars['Int']>;
  quantity: Scalars['Decimal'];
  splitChargeArgs: Array<SplitChargeArgsInput>;
  taxable: Scalars['Boolean'];
};

export type SplitChargeResponse = {
  __typename?: 'SplitChargeResponse';
  errors: Array<ValidationError>;
  splitChargeIds: Array<Scalars['Int']>;
};

export type StartRebuildProjectChargeIndexCommand = {
  batchSizeOverride?: InputMaybe<Scalars['Int']>;
};

export type StartRebuildProjectChargeIndexResponse = {
  __typename?: 'StartRebuildProjectChargeIndexResponse';
  errors: Array<ValidationError>;
  firstBatchRowsProcessed?: Maybe<Scalars['Int']>;
  targetVersion?: Maybe<Scalars['Int']>;
};

export type StateCounty = {
  __typename?: 'StateCounty';
  county: Scalars['String'];
  id: Scalars['Int'];
  state: Scalars['String'];
};

export type StateCountyInput = {
  county: Scalars['String'];
  state: Scalars['String'];
};

export type StructuralFolder = {
  __typename?: 'StructuralFolder';
  clientFolders: Array<CustomerFolder>;
  path: Scalars['String'];
};

export enum SubjectType {
  ProjectRequestCreated = 'ProjectRequestCreated',
  BaAssigned = 'BaAssigned',
  NewCustomer = 'NewCustomer',
  CustomerRequestRejected = 'CustomerRequestRejected',
  ProjectRequestCreatedWithBadDebt = 'ProjectRequestCreatedWithBadDebt',
  ThirdPartyInvoiceCreated = 'ThirdPartyInvoiceCreated'
}

export enum SyncStatus {
  Unsynced = 'Unsynced',
  Synced = 'Synced',
  InProcess = 'InProcess',
  Renamed = 'Renamed',
  Error = 'Error',
  PendingMove = 'PendingMove',
  RenameFailed = 'RenameFailed'
}

export type TaskRateSheet = {
  __typename?: 'TaskRateSheet';
  allowAssignment: Scalars['Boolean'];
  archived: Scalars['Boolean'];
  endDate?: Maybe<Scalars['LocalDate']>;
  id: Scalars['Int'];
  lastUsed?: Maybe<Scalars['LocalDate']>;
  name: Scalars['String'];
};

export type TaskRateSheetAssignment = {
  __typename?: 'TaskRateSheetAssignment';
  effectiveDate: Scalars['LocalDate'];
  rateSheet: TaskRateSheet;
};

export enum TaskRateType {
  Office = 'Office',
  Field = 'Field',
  Training = 'Training'
}

export enum TaskRateUnit {
  Hourly = 'Hourly',
  Day = 'Day',
  Each = 'Each',
  Foot = 'Foot'
}

export type TcpAllowanceExpense = IExpense & {
  __typename?: 'TcpAllowanceExpense';
  billableAmount?: Maybe<Scalars['Decimal']>;
  date: Scalars['LocalDate'];
  eeCode: Scalars['String'];
  expenseAccount?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  glAccount?: Maybe<Scalars['String']>;
  history: Array<ExpenseHistoryItem>;
  id: Scalars['String'];
  importEdited: Scalars['Boolean'];
  invoiceLabel?: Maybe<Scalars['String']>;
  lastAdminNotes?: Maybe<Scalars['String']>;
  location: StateCounty;
  notes?: Maybe<Scalars['String']>;
  payable: Payable;
  payableAmount: Scalars['Decimal'];
  payableOverridden: Scalars['Boolean'];
  projectId: Scalars['Int'];
  rateName: Scalars['String'];
  rateSheetName: Scalars['String'];
};

export type TcpAllowanceExpenseRate = IExpenseRate & {
  __typename?: 'TcpAllowanceExpenseRate';
  expenseAccount?: Maybe<Scalars['String']>;
  glAccount?: Maybe<Scalars['String']>;
  invoiceLabel?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  reimbursableAmount: Scalars['Decimal'];
  unit?: Maybe<RateUnit>;
};

export type TrainingReportArgsInput = {
  after?: InputMaybe<Scalars['LocalDate']>;
  before?: InputMaybe<Scalars['LocalDate']>;
  employeeSearch?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  trainingType?: InputMaybe<Scalars['String']>;
  workLocation?: InputMaybe<Scalars['String']>;
};

export type TrainingReportQueryModel = {
  __typename?: 'TrainingReportQueryModel';
  report: ConnectionOfTrainingReportRow;
};


export type TrainingReportQueryModelReportArgs = {
  input: TrainingReportArgsInput;
};

export type TrainingReportRow = {
  __typename?: 'TrainingReportRow';
  certificateImageId?: Maybe<Scalars['UUID']>;
  employee: Employee;
  trainingDate: Scalars['LocalDate'];
  trainingHours: Scalars['Duration'];
  trainingType: Scalars['String'];
};

export type UngroupCommand = {
  memberId: Scalars['String'];
  notes: Scalars['String'];
};

export type UpdateCorpLocationCommand = {
  companyName: Scalars['String'];
  corpLocationId: Scalars['String'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
};

export type UpdateDivisionCommand = {
  divisionId: Scalars['String'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
};

export type UpdateEeCodeActiveCommand = {
  eeCode: Scalars['String'];
  isActive: Scalars['Boolean'];
};

export type UpdateFieldOfficeProjectAffinityCommand = {
  allowsProjects: Scalars['Boolean'];
  officeCode: Scalars['String'];
};

export type UpdateOfficeOverheadEeCodeCommand = {
  eeCode: Scalars['String'];
  officeCode: Scalars['String'];
};

export type UpdateServiceDescriptionInput = {
  description: Scalars['String'];
  industry: Scalars['String'];
  legacyWorkCode: Scalars['String'];
  previousDisplayName?: InputMaybe<Scalars['String']>;
  projectType: Scalars['String'];
};

export type UpdateStateOverheadEeCodeCommand = {
  eeCode: Scalars['String'];
  state: Scalars['String'];
};

export type UpsertEeCodeCommand = {
  code: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['String']>;
};

export type UsersMutationModel = {
  __typename?: 'UsersMutationModel';
  logSessionData: ValidationResponse;
};


export type UsersMutationModelLogSessionDataArgs = {
  input: LogSessionDataCommand;
};

export type ValidationError = {
  __typename?: 'ValidationError';
  argumentName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type ValidationResponse = {
  __typename?: 'ValidationResponse';
  errors: Array<ValidationError>;
};

export const BillingFrequencyTypeLabels: Record<BillingFrequencyType, string> = {
  "Weekly": "Weekly",
  "Biweekly": "Biweekly",
  "Monthly": "Monthly",
  "UponCompletion": "UponCompletion",
};

export const ChargeTypeLabels: Record<ChargeType, string> = {
  "Task": "Task",
  "Expense": "Expense",
  "Tax": "Tax",
  "Clerical": "Clerical",
};

export const CommandAuthorizationLabels: Record<CommandAuthorization, string> = {
  "AssignTaskRateSheetToProjectCommand": "AssignTaskRateSheetToProjectCommand",
  "RemoveTaskRateSheetFromProjectCommand": "RemoveTaskRateSheetFromProjectCommand",
  "StartRebuildProjectChargeIndexCommand": "StartRebuildProjectChargeIndexCommand",
  "CreateProjectCommand": "CreateProjectCommand",
  "EditActualEndDateCommand": "EditActualEndDateCommand",
  "EditActualStartDateCommand": "EditActualStartDateCommand",
  "EditAfeCommand": "EditAfeCommand",
  "EditAllowThirdPartyInvoiceCommand": "EditAllowThirdPartyInvoiceCommand",
  "EditBillingAdminCommand": "EditBillingAdminCommand",
  "EditBillingFrequencyCommand": "EditBillingFrequencyCommand",
  "EditBlockCommand": "EditBlockCommand",
  "EditBudgetCommand": "EditBudgetCommand",
  "EditCityCommand": "EditCityCommand",
  "EditClientContactNameCommand": "EditClientContactNameCommand",
  "EditContractNumberCommand": "EditContractNumberCommand",
  "EditCorpLocationCommand": "EditCorpLocationCommand",
  "EditCostCenterCommand": "EditCostCenterCommand",
  "EditCustomerCommand": "EditCustomerCommand",
  "EditDateInCommand": "EditDateInCommand",
  "EditDescriptionCommand": "EditDescriptionCommand",
  "EditDivisionCommand": "EditDivisionCommand",
  "EditEogAfeTypeCommand": "EditEogAfeTypeCommand",
  "EditEstimatedEndDateCommand": "EditEstimatedEndDateCommand",
  "EditEstimatedStartDateCommand": "EditEstimatedStartDateCommand",
  "EditGlCodeCommand": "EditGlCodeCommand",
  "EditGovernmentFundingCommand": "EditGovernmentFundingCommand",
  "EditInternalNotesCommand": "EditInternalNotesCommand",
  "EditInvoiceNotesCommand": "EditInvoiceNotesCommand",
  "EditLatitudeCommand": "EditLatitudeCommand",
  "EditLocationCommand": "EditLocationCommand",
  "EditLongitudeCommand": "EditLongitudeCommand",
  "EditNetworkPathCommand": "EditNetworkPathCommand",
  "EditOfficeCodeCommand": "EditOfficeCodeCommand",
  "EditPoCommand": "EditPoCommand",
  "EditProjectCertifiedPayrollCommand": "EditProjectCertifiedPayrollCommand",
  "EditProjectManagerCommand": "EditProjectManagerCommand",
  "EditProjectNameCommand": "EditProjectNameCommand",
  "EditProjectOriginationCommand": "EditProjectOriginationCommand",
  "EditProjectProjectGroupCommand": "EditProjectProjectGroupCommand",
  "EditProjectStatusCommand": "EditProjectStatusCommand",
  "EditProjectSupervisorCommand": "EditProjectSupervisorCommand",
  "EditRangeCommand": "EditRangeCommand",
  "EditRequisitionerCommand": "EditRequisitionerCommand",
  "EditScopeCommand": "EditScopeCommand",
  "EditSectionCommand": "EditSectionCommand",
  "EditServiceDescriptionCommand": "EditServiceDescriptionCommand",
  "EditSurveyCommand": "EditSurveyCommand",
  "EditTownshipCommand": "EditTownshipCommand",
  "EditWoCommand": "EditWoCommand",
  "CreateProjectGroupCommand": "CreateProjectGroupCommand",
  "EditProjectGroupCommand": "EditProjectGroupCommand",
  "CreateInvoiceChargeCommand": "CreateInvoiceChargeCommand",
  "AddProductRateCommand": "AddProductRateCommand",
  "CreateProductCommand": "CreateProductCommand",
  "RenameProductCommand": "RenameProductCommand",
  "AddRatesCommand": "AddRatesCommand",
  "AddChargesToInvoiceCommand": "AddChargesToInvoiceCommand",
  "AddChargeToInvoiceCommand": "AddChargeToInvoiceCommand",
  "BillInvoiceCommand": "BillInvoiceCommand",
  "CreateInvoiceCommand": "CreateInvoiceCommand",
  "RemoveChargeFromInvoiceCommand": "RemoveChargeFromInvoiceCommand",
  "OverrideCustomerFolderSyncCommand": "OverrideCustomerFolderSyncCommand",
  "OverrideGroupedFolderSyncCommand": "OverrideGroupedFolderSyncCommand",
  "OverrideProjectFolderSyncCommand": "OverrideProjectFolderSyncCommand",
  "CompleteProjectFolderMoveCommand": "CompleteProjectFolderMoveCommand",
  "CompleteGroupedFolderMoveCommand": "CompleteGroupedFolderMoveCommand",
  "RequestProjectFolderMoveCommand": "RequestProjectFolderMoveCommand",
  "RequestGroupedFolderMoveCommand": "RequestGroupedFolderMoveCommand",
  "AddProjectToGroupedFolderCommand": "AddProjectToGroupedFolderCommand",
  "CreateGroupedFolderForProjectCommand": "CreateGroupedFolderForProjectCommand",
  "CreateProjectFolderCommand": "CreateProjectFolderCommand",
  "AddProjectRequestReviewerCommand": "AddProjectRequestReviewerCommand",
  "RemoveProjectRequestReviewerCommand": "RemoveProjectRequestReviewerCommand",
  "UpdateFieldOfficeProjectAffinityCommand": "UpdateFieldOfficeProjectAffinityCommand",
  "AssignToProjectCommand": "AssignToProjectCommand",
  "EditRateSheetCommand": "EditRateSheetCommand",
  "RemoveExpenseRateSheetFromProjectCommand": "RemoveExpenseRateSheetFromProjectCommand",
  "UpdateDefaultDriveCommand": "UpdateDefaultDriveCommand",
  "CreateEmployeeRateCommand": "CreateEmployeeRateCommand",
  "DeleteEmployeeRateCommand": "DeleteEmployeeRateCommand",
  "EditEmployeeRateCommand": "EditEmployeeRateCommand",
  "UpdateEeCodeActiveCommand": "UpdateEeCodeActiveCommand",
  "UpdateOfficeOverheadEeCodeCommand": "UpdateOfficeOverheadEeCodeCommand",
  "UpdateStateOverheadEeCodeCommand": "UpdateStateOverheadEeCodeCommand",
  "UpsertEeCodeCommand": "UpsertEeCodeCommand",
  "AddRollupInvoiceLineItemCommand": "AddRollupInvoiceLineItemCommand",
  "BillRollupInvoiceCommand": "BillRollupInvoiceCommand",
  "BulkAddRollupLineItemsCommand": "BulkAddRollupLineItemsCommand",
  "CancelRollupInvoiceCommand": "CancelRollupInvoiceCommand",
  "CreateRollupInvoiceCommand": "CreateRollupInvoiceCommand",
  "EditRollupInvoiceCommand": "EditRollupInvoiceCommand",
  "RemoveRollupInvoiceLineItemCommand": "RemoveRollupInvoiceLineItemCommand",
  "ApproveCustomerCommand": "ApproveCustomerCommand",
  "RejectCustomerCommand": "RejectCustomerCommand",
  "CreateCustomerCommand": "CreateCustomerCommand",
};

export const CrewRoleLabels: Record<CrewRole, string> = {
  "CrewChief": "CrewChief",
  "Rodman": "Rodman",
  "IMan": "IMan",
};

export const CustomerStatusLabels: Record<CustomerStatus, string> = {
  "Approved": "Approved",
  "InProjectRequest": "InProjectRequest",
  "Pending": "Pending",
  "Rejected": "Rejected",
};

export const CustomRollupInvoiceSortByLabels: Record<CustomRollupInvoiceSortBy, string> = {
  "CustomerName": "Customer Name",
  "InvoiceNumber": "Invoice Number",
};

export const ElectronicInvoicingSystemLabels: Record<ElectronicInvoicingSystem, string> = {
  "Actian": "Actian",
  "Ariba": "Ariba",
  "OpenInvoice": "OpenInvoice",
  "SmartGEP": "SmartGEP",
};

export const GovernmentFundingTypeLabels: Record<GovernmentFundingType, string> = {
  "None": "None",
  "Federal": "Federal",
  "State": "State",
  "County": "County",
  "City": "City",
};

export const InvoiceFilterStateLabels: Record<InvoiceFilterState, string> = {
  "Any": "Any",
  "Draft": "Draft",
  "Billed": "Billed",
  "Cancelled": "Cancelled",
};

export const InvoiceStateLabels: Record<InvoiceState, string> = {
  "Draft": "Draft",
  "Billed": "Billed",
  "Cancelled": "Cancelled",
};

export const MenuAuthorizationsLabels: Record<MenuAuthorizations, string> = {
  "None": "None",
  "Impersonate": "Impersonate",
  "Rates": "Rates",
  "Customers": "Customers",
  "Expenses": "Expenses",
  "FieldOffices": "FieldOffices",
  "Invoices": "Invoices",
  "EeCodes": "EeCodes",
  "PendingCustomers": "PendingCustomers",
  "Projects": "Projects",
  "ProjectCharges": "ProjectCharges",
  "SalesTaxReport": "SalesTaxReport",
  "TimesheetReview": "TimesheetReview",
  "CorporateStructure": "CorporateStructure",
  "ProjectRequests": "ProjectRequests",
  "RequestNewProject": "RequestNewProject",
  "CreateNewProject": "CreateNewProject",
  "EmployeeRoles": "EmployeeRoles",
  "OfficeBillingReport": "OfficeBillingReport",
  "PerformanceStats": "PerformanceStats",
  "RevenueReports": "RevenueReports",
  "Products": "Products",
  "Employees": "Employees",
  "ThirdPartyInvoices": "ThirdPartyInvoices",
  "ViewProjectStatus": "ViewProjectStatus",
  "UnbilledProjectCharges": "UnbilledProjectCharges",
  "EditProject": "EditProject",
  "ViewAllProjectFolders": "ViewAllProjectFolders",
  "NewProjectChargeEditor": "NewProjectChargeEditor",
  "ViewProjectFolders": "ViewProjectFolders",
  "OverrideRate": "OverrideRate",
  "TrainingReports": "TrainingReports",
  "AdministrateFolders": "AdministrateFolders",
  "DailyProjectExport": "DailyProjectExport",
};

export const PayableLabels: Record<Payable, string> = {
  "Payroll": "Payroll",
  "Reimbursement": "Reimbursement",
  "None": "None",
  "Invoice": "Invoice",
};

export const PayerInformationLabels: Record<PayerInformation, string> = {
  "Company": "Company",
  "Employee": "Employee",
};

export const PayPeriodLabels: Record<PayPeriod, string> = {
  "Weekly": "Weekly",
  "Biweekly": "Biweekly",
};

export const PerDiemKindLabels: Record<PerDiemKind, string> = {
  "Meals": "Meals",
  "Lodging": "Lodging",
  "Travel": "Travel",
  "TravelMeals": "TravelMeals",
};

export const PriceClassificationLabels: Record<PriceClassification, string> = {
  "Fixed": "Fixed",
  "Variable": "Variable",
  "PerDiem": "PerDiem",
  "EmployeeRate": "EmployeeRate",
};

export const ProductUnitLabels: Record<ProductUnit, string> = {
  "Hourly": "Hourly",
  "Day": "Day",
  "Each": "Each",
  "Foot": "Foot",
  "Mile": "Mile",
  "Gallon": "Gallon",
};

export const ProjectChargeStateLabels: Record<ProjectChargeState, string> = {
  "Archived": "Archived",
  "Cancelled": "Cancelled",
  "PmPending": "PmPending",
  "PsPending": "PsPending",
  "BaPending": "BaPending",
  "PostPending": "PostPending",
  "PostedNotBilled": "PostedNotBilled",
  "Billed": "Billed",
  "PrPending": "PrPending",
};

export const ProjectOriginationLabels: Record<ProjectOrigination, string> = {
  "BdMcBee": "BD - McBee",
  "BdStorozyszyn": "BD - Storozyszyn",
  "BdShablo": "BD - Shablo",
  "BdLueders": "BD - Lueders",
  "BidPublicationService": "Bid Publication Service",
  "CivilSurveyDepartment": "Civil Survey Department",
  "ConstructionDepartment": "Construction Department",
  "EngineeringDepartment": "Engineering Department",
  "EnvironmentalDepartment": "Environmental Department",
  "ExistingCustomer": "Existing Customer",
  "Event": "Event",
  "Facebook": "Facebook",
  "GeospatialDepartment": "Geospatial Department",
  "Google": "Google",
  "Instragram": "Instagram",
  "Referral": "Referral",
  "SurveyDepartment": "Survey Department",
  "TopographicWebsite": "Topographic Website",
  "Unset": "Unset",
};

export const ProjectStatusLabels: Record<ProjectStatus, string> = {
  "Active": "Active",
  "Closed": "Closed",
};

export const ProjectTimeDailyRoleLabels: Record<ProjectTimeDailyRole, string> = {
  "FieldSupervisor": "FieldSupervisor",
  "LeadPartyChief": "LeadPartyChief",
  "PartyChief": "PartyChief",
  "InstrumentTech": "InstrumentTech",
  "RodMan": "RodMan",
};

export const RateUnitLabels: Record<RateUnit, string> = {
  "Hourly": "Hourly",
  "Day": "Day",
  "Each": "Each",
  "Foot": "Foot",
  "Mile": "Mile",
  "Gallon": "Gallon",
};

export const ReceiptValuedCategoryLabels: Record<ReceiptValuedCategory, string> = {
  "Automotive": "Automotive",
  "Lodging": "Lodging",
  "Meals": "Meals",
  "None": "None",
};

export const SubjectTypeLabels: Record<SubjectType, string> = {
  "ProjectRequestCreated": "ProjectRequestCreated",
  "BaAssigned": "BaAssigned",
  "NewCustomer": "NewCustomer",
  "CustomerRequestRejected": "CustomerRequestRejected",
  "ProjectRequestCreatedWithBadDebt": "ProjectRequestCreatedWithBadDebt",
  "ThirdPartyInvoiceCreated": "ThirdPartyInvoiceCreated",
};

export const SyncStatusLabels: Record<SyncStatus, string> = {
  "Unsynced": "Unsynced",
  "Synced": "Synced",
  "InProcess": "InProcess",
  "Renamed": "Renamed",
  "Error": "Error",
  "PendingMove": "PendingMove",
  "RenameFailed": "RenameFailed",
};

export const TaskRateTypeLabels: Record<TaskRateType, string> = {
  "Office": "Office",
  "Field": "Field",
  "Training": "Training",
};

export const TaskRateUnitLabels: Record<TaskRateUnit, string> = {
  "Hourly": "Hourly",
  "Day": "Day",
  "Each": "Each",
  "Foot": "Foot",
};
